import { t } from "i18next";
import { filter } from "lodash";

let store;
export const injectConstStore = (_store) => {
  store = _store;
};

export const ERROR_MSG = "It looks like I’m unable to retrieve that information right now. Please try again later.";

export const DEFAULT_SESSION_ID = "fake_hyly_session_id";

export const INITIAL_MSGS = [{ message: "welcomeMessage", speaker: "bot", createdAt: new Date(), isInitMessage: true }];

export const ESSENTIAL_VALUES = ["property_id", "api_key", "appSSID"];

export const INITIAL_REPLY_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "search", label: "findHome", callbackOptions: null, type: "exploreContact" },
    },
    nextOptionsType: "BedroomTypes",
    message: [{ message: "findHome", speaker: "user" }],
    key: "find_home",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "clock", label: "scheduleTour", callbackOptions: null, type: "exploreContact" },
    },
    nextOptionsType: "Form4ScheduleTour",
    message: [{ message: "scheduleTour", speaker: "user" }],
    key: "schedule_tour",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "photos", callbackOptions: null, type: "learnMore" },
    },
    nextOptionsType: "Photos",
    message: [{ message: "photos", speaker: "user" }],
    key: "photos",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "videos", callbackOptions: null, type: "learnMore" },
    },
    nextOptionsType: "Videos",
    message: [{ message: "videos", speaker: "user" }],
    key: "videos",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "communityInfo", callbackOptions: null, type: "learnMore" },
    },
    nextOptionsType: "CommunityInfo",
    message: [{ message: "communityInfo", speaker: "user", type: "learnMore" }],
    key: "community_info",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "send", label: "contactMe", callbackOptions: null, type: "exploreContact" },
    },
    nextOptionsType: "Form4ContactUs",
    message: [{ message: "contactMe", speaker: "user" }],
    key: "contact_us",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "residentalPortal", callbackOptions: null, type: "quickActions" },
    },
    nextOptionsType: "VisitResidentPortal",
    message: [{ message: "residentalPortal", speaker: "user" }],
    key: "visit_resident_portal",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  // {
  //   content: {
  //     component: "NormalOptionTile",
  //     componentOptions: { icon: "", label: "Ask Me Anything", callbackOptions: null, type: "quickActions" },
  //   },
  //   nextOptionsType: "FAQs",
  //   message: [{ message: "Ask Me Anything", speaker: "user" }],
  //   key: "faqs",
  //   event: "h_click",
  //   disablePlaceholerMessage: false,
  //   data: null,
  // },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "doIQualify", callbackOptions: null, type: "quickActions" },
    },
    nextOptionsType: "DoIQualify",
    message: [{ message: "doIQualify", speaker: "user" }],
    key: "do_i_qualify",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const CANCEL_TOUR_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "Yes, cancel", callbackOptions: null, type: "" },
    },
    nextOptionsType: "cancelTour",
    message: [{ message: "Yes, cancel", speaker: "user" }],
    key: "cancel_tour",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "No, don't cancel", callbackOptions: null, type: "" },
    },
    nextOptionsType: "noDoNotCancel",
    message: [{ message: "No, don't cancel", speaker: "user" }],
    key: "no_donot_cancel",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const RESCHEDULE_TOUR_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "Reschedule Tour", callbackOptions: null, type: "" },
    },
    nextOptionsType: "rescheduleFromTourStatus",
    message: [{ message: "Reschedule Tour", speaker: "user" }],
    key: "rescheduleFromTourStatus",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "Cancel Tour", callbackOptions: null, type: "" },
    },
    nextOptionsType: "cancelTourFromTourStatus",
    message: [{ message: "Cancel Tour", speaker: "user" }],
    key: "cancelTourFromTourStatus",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const CUSTOM_BUTTON = {
  content: {
    component: "LinkOptionTile",
    componentOptions: {
      icon: "OpenLinkIcon",
      label: "Apply Now",
      link: "https://www.propertysite.com/applynow",
      id: "",
      type: "quickActions",
    },
  },
  message: [],
  nextOptionsType: null,
  key: "custom_btn",
  event: "h_click",
  disablePlaceholerMessage: false,
  data: null,
};

const FEEDBACK_TOUR_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "like", label: "excellent", callbackOptions: null },
    },
    nextOptionsType: "LikeTour",
    message: [{ message: "excellent", speaker: "user" }],
    key: "thumbs_up",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: "thumbs_up",
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "dislike", label: "needImprovement", callbackOptions: null },
    },
    nextOptionsType: "DisLikeTour",
    message: [{ message: "needImprovement", speaker: "user" }],
    key: "thumbs_down",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: "thumbs_down",
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "skip", callbackOptions: null },
    },
    nextOptionsType: "SkipTour",
    message: [{ message: "skip", speaker: "user" }],
    key: "skip",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: "skip",
  },
];

const FEEDBACK_CONTACT_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "like", label: "excellent", callbackOptions: null },
    },
    nextOptionsType: "LikeContact",
    message: [{ message: "excellent", speaker: "user" }],
    key: "thumbs_up",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: "thumbs_up",
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "dislike", label: "needImprovement", callbackOptions: null },
    },
    nextOptionsType: "DisLikeContact",
    message: [{ message: "needImprovement", speaker: "user" }],
    key: "thumbs_down",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: "thumbs_down",
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: "", label: "skip", callbackOptions: null },
    },
    nextOptionsType: "SkipContact",
    message: [{ message: "skip", speaker: "user" }],
    key: "skip",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: "skip",
  },
];

export const RETRY_OPTION = {
  content: {
    component: "NormalOptionTile",
    componentOptions: { icon: "", label: "retry", callbackOptions: null },
  },
  nextOptionsType: "Init",
  message: [],
  key: "retry",
  event: "h_click",
  disablePlaceholerMessage: false,
  data: null,
};

export const EXPLORE_MORE_OPTION = {
  content: {
    component: "NormalOptionTile",
    componentOptions: { icon: "", label: "exploreMore", callbackOptions: null },
  },
  nextOptionsType: "Init",
  message: [{ message: "exploreMore", speaker: "user" }],
  key: "exploreMore",
  event: "h_click",
  disablePlaceholerMessage: false,
  data: null,
};

export const SHOW_ALL_UNITS_OPTION = {
  content: {
    component: "NormalOptionTile",
    componentOptions: { icon: "", label: "showAllUnit", callbackOptions: null },
  },
  nextOptionsType: "UnitsAll",
  message: [{ message: "showAllUnit", speaker: "user" }],
  key: "bedrooms",
  event: "h_click",
  disablePlaceholerMessage: false,
  data: null,
};

export const FORM_4_SCHEDULE_TOUR_OPTIONS = [
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "firstName",
        type: "text",
        label: "firstName",
        officialLabel: "first name",
        validate: "TEXT_ONLY",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostScheduleTour",
    key: "first_name",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "lastName",
        type: "text",
        label: "lastName",
        officialLabel: "last name",
        validate: "TEXT_ONLY",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostScheduleTour",
    key: "last_name",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "email",
        type: "email",
        label: "email",
        officialLabel: "email",
        validate: "EMAIL",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostScheduleTour",
    key: "email",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "phoneNumber",
        type: "text",
        label: "phoneNumber",
        officialLabel: "phone number",
        validate: "PHONE",
        callbackOptions: null,
        isOptional: true,
      },
    },
    nextOptionsType: "PostScheduleTour",
    message: [],
    key: "phone",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const FORM_4_CONTACT_US_OPTIONS = [
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "firstName",
        type: "text",
        label: "firstName",
        officialLabel: "first name",
        validate: "TEXT_ONLY",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostContactUs",
    key: "first_name",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "lastName",
        type: "text",
        label: "lastName",
        officialLabel: "last name",
        validate: "TEXT_ONLY",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostContactUs",
    key: "last_name",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "email",
        type: "email",
        label: "email",
        officialLabel: "email",
        validate: "EMAIL",
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "PostContactUs",
    key: "email",
    isRequired: true,
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "phoneNumber",
        type: "text",
        label: "phoneNumber",
        officialLabel: "phone number",
        validate: "PHONE",
        callbackOptions: null,
        isOptional: true,
      },
    },
    nextOptionsType: "PostContactUs",
    message: [],
    key: "phone",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const FAQS_OPTIONS = [
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "Enter your question here...",
        type: "text",
        label: "AMA",
        officialLabel: "AMA",
        validate: null,
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: null,
    key: "faqs",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const WHEN_MOVE_IN_OPTIONS = [
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "asap", callbackOptions: null },
    },
    nextOptionsType: "Units",
    message: [{ message: "asap", speaker: "user" }],
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "next30Days", callbackOptions: null },
    },
    nextOptionsType: "Units",
    message: [{ message: "next30Days", speaker: "user" }],
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "next60Days", callbackOptions: null },
    },
    nextOptionsType: "Units",
    message: [{ message: "next60Days", speaker: "user" }],
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
  {
    content: {
      component: "DatePickerOptionTile",
      componentOptions: {
        disablePreviousDates: true,
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "Units",
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "notSure", callbackOptions: null },
    },
    nextOptionsType: "Units",
    message: [{ message: "notSure", speaker: "user" }],
    key: "movein date",
    event: "h_click",
    disablePlaceholerMessage: true,
    data: null,
  },
];

export const VISIT_RESIDENT_PORTAL_OPTIONS = [
  {
    content: {
      component: "LinkOptionTile",
      componentOptions: {
        icon: "OpenLinkIcon",
        label: "takeResidentalPortal",
        link: "",
      },
    },
    message: [],
    nextOptionsType: null,
    key: "go_to_resident_portal",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "exploreMore", callbackOptions: null },
    },
    nextOptionsType: "Initx",
    message: [{ message: "exploreMore", speaker: "user" }],
    key: "exploreMore",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const SELF_TOUR_OPTIONS = [
  {
    content: {
      component: "LinkOptionTile",
      componentOptions: {
        icon: null,
        label: "proceedSelfGuideTour",
        link: "",
      },
    },
    message: [],
    nextOptionsType: null,
    key: "proceed_self_tour",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
  {
    content: {
      component: "NormalOptionTile",
      componentOptions: { icon: null, label: "goBack", callbackOptions: null },
    },
    nextOptionsType: "ScheduleTour",
    message: [{ message: "goBack", speaker: "user" }],
    key: "go_back",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const DO_I_QUALIFY_OPTIONS = [
  {
    content: {
      component: "FullWidthInput",
      componentOptions: {
        placeholder: "Enter the amount here...",
        type: "number",
        label: "doIQualify",
        officialLabel: "doIQualify",
        validate: null,
        callbackOptions: null,
      },
    },
    message: [],
    nextOptionsType: "Init",
    key: "do_i_qualify",
    event: "h_click",
    disablePlaceholerMessage: false,
    data: null,
  },
];

export const INITIAL_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: INITIAL_REPLY_OPTIONS,
  optionsType: "Init",
  title: "",
  renderType: "boxView",
  optionLabel: "",
  // optionLabel: "selectToContinue",
};

export const CANCEL_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: CANCEL_TOUR_OPTIONS,
  optionsType: "",
  title: "",
  renderType: "boxView",
  optionLabel: "",
  // optionLabel: "selectToContinue",
};

export const RESCHEDULE_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: RESCHEDULE_TOUR_OPTIONS,
  optionsType: "",
  title: "",
  renderType: "boxView",
  optionLabel: "",
  // optionLabel: "selectToContinue",
};

export const POST_CONTACT_US_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: filter(INITIAL_REPLY_OPTIONS, (o) => !["contact_us"].includes(o.key)),
  optionsType: "Init",
  title: "",
  renderType: "boxView",
};

export const POST_SCHEDULE_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: filter(INITIAL_REPLY_OPTIONS, (o) => !["schedule_tour"].includes(o.key)),
  optionsType: "Init",
  title: "",
  renderType: "boxView",
};

export const RETRY_OPTION_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: [RETRY_OPTION, EXPLORE_MORE_OPTION],
  optionsType: "Init",
  title: "",
  renderType: "boxView",
};

export const FEEDBACK_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: FEEDBACK_TOUR_OPTIONS,
  optionsType: "Feedback",
  title: "",
  renderType: "boxView",
};

export const FEEDBACK_CONTACT_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: FEEDBACK_CONTACT_OPTIONS,
  optionsType: "Feedback",
  title: "",
  renderType: "boxView",
};

export const FORM_4_SCHEDULE_TOUR_REPLIES = {
  checkStorage: true,
  disableResetBox: false,
  options: FORM_4_SCHEDULE_TOUR_OPTIONS,
  optionsType: "Form4ScheduleTour",
  title: "Enter First Name, Last Name, Email, and Phone Number (optional)",
  renderType: "multiInputView",
};

export const FORM_4_CONTACT_US_REPLIES = {
  checkStorage: true,
  disableResetBox: false,
  options: FORM_4_CONTACT_US_OPTIONS,
  optionsType: "Form4ContactUs",
  title: "Enter First Name and Last Name",
  renderType: "multiInputView",
};

export const FAQS_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: FAQS_OPTIONS,
  optionsType: "FAQs",
  title: "What would you like to know about this property?",
  renderType: "inputView",
};

export const WHEN_MOVE_IN_REPLIES = {
  checkStorage: false,
  disableResetBox: false,
  options: WHEN_MOVE_IN_OPTIONS,
  optionsType: "WhenMoveIn",
  title: "",
  renderType: "boxView",
};

export const VISIT_RESIDENT_PORTAL_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: VISIT_RESIDENT_PORTAL_OPTIONS,
  optionsType: "VisitResidentPortal",
  title: "",
  renderType: "boxView",
};

export const SELF_TOUR_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: SELF_TOUR_OPTIONS,
  optionsType: "SelfTour",
  title: "",
  renderType: "boxView",
};
export const DO_I_QUALIFY_REPLIES = {
  checkStorage: false,
  disableResetBox: true,
  options: DO_I_QUALIFY_OPTIONS,
  optionsType: "DoIQualify",
  title: "",
  renderType: "inputView",
};

export const wrapLines = (str, maxLen) => {
  let reg = new RegExp("(?=\\S).{0," + (maxLen - 1) + "}\\S(?!\\S)|\\S{" + maxLen + "}", "gm");

  return Array.from(str.matchAll(reg), (m) => m[0]);
};

export const initialKeyOptions = {
  BedroomTypes: "find a home",
  PostScheduleTour: "scheduled tour",
  ScheduleTour: "schedule a tour",
  Form4ScheduleTour: "schedule a tour",
  Photos: "photos",
  Videos: "videos",
  CommunityInfo: "community info",
  PostContactUs: "guest card",
  Form4ContactUs: "contact us",
  VisitResidentPortal: "resident portal",
  FAQs: "faqs",
};

export const feedbackKeyOptions = {
  LikeTour: "schedule_a_tour",
  DisLikeTour: "schedule_a_tour",
  SkipTour: "schedule_a_tour",
  LikeContact: "contact_us",
  DisLikeContact: "contact_us",
  SkipContact: "contact_us",
};

export const dotLoader = `<span style="animation-delay: 300ms;" class="bounce-dot hayley-inline-block hayley-w-1 hayley-h-1 hayley-rounded-full hayley-bg-black"></span>
  <span style="animation-delay: 600ms;" class="bounce-dot hayley-inline-block hayley-w-1 hayley-h-1 hayley-rounded-full hayley-bg-black"></span>
  <span style="animation-delay: 900ms;" class="bounce-dot hayley-inline-block hayley-w-1 hayley-h-1 hayley-rounded-full hayley-bg-black"></span>
  `;

export const optionTypes = {
  PostScheduleTour: `confirmingTour`,
  PostContactUs: `submitContactForm`,
  Photos: `loadingPhotos`,
  Videos: `loadingVideos`,
  CommunityInfo: `loadingCommunityInfo`,
  VisitResidentPortal: `loadingOptions`,
  UnitsAll: `loadingAllUnit`,
};

export const loaders = [
  `confirmingTour`,
  `submitContactForm`,
  `loadingPhotos`,
  `loadingVideos`,
  `loadingCommunityInfo`,
  `loadingOptions`,
  `loadingAllUnit`,
  "loadingUnits",
  "typing",
  "loading",
];

export const hotKeysOptions = {
  find_home: "find a home",
  schedule_tour: "schedule a tour",
  photos: "photos",
  videos: "videos",
  community_info: "community info",
  contact_us: "contact me",
  visit_resident_portal: "resident portal",
};

export const translation = (id, value) => {
  const lang = t(id) === id ? value : t(id);

  return lang;
};

export const UNIT_TYPE_LABELS = {
  studio: "Studio",
  "0-bedroom": "0 Bed",
  "1-bedroom": "1 Bed",
  "2-bedrooms": "2 Bed",
  "3-bedrooms": "3 Bed",
  "4-bedrooms": "4 Bed",
};

export const detectAndGenerateLinks = (text) => {
  // Regular expressions for detecting email, phone, and URL
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
  const phoneRegex = /(?:\(\d{3}\)|\d{3})[-.\s]? *\d{3}[-.\s]?\d{4}\b/g;
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Replace email addresses with HTML mailto links
  const textWithEmailLinks = text?.replace(
    emailRegex,
    '<a href="mailto:$&" class="hayley-font-semibold hayley-cursor-pointer hayley-underline hayley-text-[#4f6fae] hover:hayley-text-primary">$&</a>'
  );

  // Replace phone numbers with HTML tel links
  const textWithPhoneLinks = textWithEmailLinks?.replace(
    phoneRegex,
    '<a href="tel:$&" class="hayley-font-semibold hayley-cursor-pointer hayley-underline hayley-text-[#4f6fae] hover:hayley-text-primary">$&</a>'
  );

  // Replace URLs with HTML links
  const textWithUrlLinks = textWithPhoneLinks?.replace(
    urlRegex,
    '<a href="$&" target="_blank" class="hayley-font-semibold hayley-cursor-pointer hayley-underline hayley-text-[#4f6fae] hover:hayley-text-primary">$&</a>'
  );

  return textWithUrlLinks;
};

export const getWidgetRefHeight = (position, hotkeysRef, mascotHeight) => {
  if (position === "sticky-right") {
    return "120px";
  }

  const hotKeysHeight = `${(hotkeysRef?.scrollHeight || 0) + mascotHeight}px`;

  return hotKeysHeight;
};

export const getWidgetHeight = (settings, messages, position, promotionOffer, mascotHeight) => {
  if (position === "sticky-right") {
    return `120px`;
  }

  if (messages?.length > 2) {
    return `${20 + 20 + mascotHeight}px`;
  }

  if (settings?.bubbleType == "offers") {
    const length = wrapLines(promotionOffer?.description || "", 35)?.length || 0;

    const endDateTextHeight = promotionOffer?.dynamic_end_date_text ? 20 : 0;

    const calculateHeight = 20 * (length + 1);
    // padding + closeIcon + widgetIcon
    const totalHeight = 28 + 28 + mascotHeight + calculateHeight + endDateTextHeight;

    return `${length ? totalHeight : mascotHeight}px`;
  }

  if (settings?.bubbleType == "quick_actions") {
    const length = settings?.quickActions?.length || 0;

    const calculateHeight = 20 * length;
    // padding + closeIcon + widgetIcon
    const totalHeight = 28 + 28 + mascotHeight + calculateHeight;

    return `${length ? totalHeight : mascotHeight}px`;
  }

  if (settings?.bubbleType == "welcome_message") {
    const length = wrapLines(settings?.welcomeMessage, 35)?.length || 0;

    const calculateHeight = 20 * length;
    // padding + closeIcon + widgetIcon
    const totalHeight = 28 + 28 + mascotHeight + calculateHeight;

    return `${length ? totalHeight : mascotHeight}px`;
  }

  return `${mascotHeight}px`;
};

export const numberCommaFormat = (number) => {
  if (typeof number !== "number") {
    return number;
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const filterFaqOptions = (obj) => {
  const {
    showFaq,
    photos,
    videos,
    community_info,
    visit_resident_portal,
    find_a_home,
    // schedule_a_tour,
    in_person_tour,
    live_video_tour,
    self_guided_tour,
  } = store.getState().property;

  const filteredOptions = filter(obj.options, (o) => {
    if (o.key === "find_home" && !find_a_home) {
      return false;
    }

    if (o.key === "visit_resident_portal" && !visit_resident_portal) {
      return false;
    }

    if (o.key === "photos" && !photos) {
      return false;
    }

    if (o.key === "videos" && !videos) {
      return false;
    }

    if (o.key === "community_info" && !community_info) {
      return false;
    }

    if (o.key === "schedule_tour" && !(in_person_tour || live_video_tour || self_guided_tour)) {
      return false;
    }

    if (o.key === "faqs" && !showFaq) {
      return false;
    }

    return true;
  });

  const data = {
    ...obj,
    options: filteredOptions,
  };

  return data;
};

export const compMsgKeys = {
  unitView: "find_home",
  galleryView: "photos",
  videosGalleryView: "videos",
  featuresView: "community_info",
};

export const defaultEditFormats = [
  // "PostContactUs",
  // "PostScheduleTour",
  "BedroomTypes",
  "ScheduleTour",
  "Photos",
  "Videos",
  "Form4ContactUs",
  "VisitResidentPortal",
  "CommunityInfo",
  "FAQs",
];

export const reportIds = ["1528252253585581240"];

function toCamelCase(str) {
  return str
    .split(" ")
    .map((word, index) => {
      if (index === 0) {
        return word.toLowerCase();
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join("")
    .replace(/[^a-zA-Z0-9]/g, "");
}

export function filterRepliesByOptions(originalReplies, optionsFromAPI) {
  const optionsFromAPILowercase = optionsFromAPI?.map((option) => option?.toLowerCase());
  const optionsFromAPICamelCase = optionsFromAPI?.map((option) => toCamelCase(option));

  const filteredOptions = originalReplies.options.filter((option) => {
    const optionLabelLowercase = option.content.componentOptions.label;

    return (
      optionsFromAPICamelCase.includes(optionLabelLowercase) ||
      optionsFromAPILowercase.includes(optionLabelLowercase) ||
      optionLabelLowercase === "notSure" ||
      option.content.component === "DatePickerOptionTile"
    );
  });

  return {
    ...originalReplies,
    options: filteredOptions,
  };
}

export const optionsBySubject = {
  photos: "Photos",
  "schedule a tour": "ScheduleTour",
  "unit availability": "BedroomTypes",
  "resident portal": "VisitResidentPortal",
  videos: "Videos",
};

export const EVENT_TAGS = {
  find_home: "FAA_CLICKED",
  "price range": "FAA_CLICKED",
  "movein date": "FAA_CLICKED",
  schedule_tour: "SAT_CLICKED",
  bedrooms: "FAA_CLICKED",
  contact_us: "CONTACT_ME_CLICKED",
  photos: "PHOTOS_CLICKED",
  videos: "VIDEOS_CLICKED",
  community_info: "COMMUNITY_INFO_CLICKED",
  visit_resident_portal: "RESIDENT_PORTAL_CLICKED",
  do_i_qualify: "DO_I_QUALIFY_CLICKED",
  custom_btn: "CUSTOM_BUTTON_CLICKED",
};
export const EVENT_Keys = {
  find_home: "find a home",
  "price range": "price range",
  "movein date": "move in date",
  schedule_tour: "schedule a tour",
  bedrooms: "bedrooms",
  contact_us: "contact me",
  photos: "photos",
  videos: "videos",
  community_info: "community info",
  visit_resident_portal: "resident portal",
  do_i_qualify: "do i qualify",
  custom_btn: "custom button",
};

export const FOLLOW_UP_KEYS = [
  "negative feedback",
  "negative sentiment",
  "unsatisfactory answer",
  "off topic questions",
  "complaint filing",
  "seeking clarification",
  "prompt injection",
  "family friendly_housing",
  "gender inclusiveness",
  "community security",
  "cultural inclusivity",
  "accessibility features",
  "seeking help",
];

export const TOUR_MSGS_KEY = {
  cancelTour: "Yes, cancel",
  noDoNotCancel: "No, don't cancel",
};

export const chatData = {
  response: {
    description: "The earliest available appointment for an in person tour is tomorrow at 7:00 am.",
    available_slots: [
      {
        in_person_tour: [
          {
            timestamp: 1746874800,
            time_slot: "2025-05-10  7:00:00 AM",
          },
          {
            timestamp: 1746876600,
            time_slot: "2025-05-10  7:30:00 AM",
          },
          {
            timestamp: 1746878400,
            time_slot: "2025-05-10  8:00:00 AM",
          },
          {
            timestamp: 1746880200,
            time_slot: "2025-05-10  8:30:00 AM",
          },
          {
            timestamp: 1746882000,
            time_slot: "2025-05-10  9:00:00 AM",
          },
          {
            timestamp: 1746883800,
            time_slot: "2025-05-10  9:30:00 AM",
          },
          {
            timestamp: 1746885600,
            time_slot: "2025-05-10 10:00:00 AM",
          },
          {
            timestamp: 1746887400,
            time_slot: "2025-05-10 10:30:00 AM",
          },
          {
            timestamp: 1746889200,
            time_slot: "2025-05-10 11:00:00 AM",
          },
          {
            timestamp: 1746891000,
            time_slot: "2025-05-10 11:30:00 AM",
          },
          {
            timestamp: 1746894600,
            time_slot: "2025-05-10 12:30:00 PM",
          },
          {
            timestamp: 1746896400,
            time_slot: "2025-05-10  1:00:00 PM",
          },
          {
            timestamp: 1746898200,
            time_slot: "2025-05-10  1:30:00 PM",
          },
          {
            timestamp: 1746900000,
            time_slot: "2025-05-10  2:00:00 PM",
          },
          {
            timestamp: 1746901800,
            time_slot: "2025-05-10  2:30:00 PM",
          },
          {
            timestamp: 1746903600,
            time_slot: "2025-05-10  3:00:00 PM",
          },
          {
            timestamp: 1746957600,
            time_slot: "2025-05-11  6:00:00 AM",
          },
          {
            timestamp: 1746959400,
            time_slot: "2025-05-11  6:30:00 AM",
          },
          {
            timestamp: 1746961200,
            time_slot: "2025-05-11  7:00:00 AM",
          },
          {
            timestamp: 1746963000,
            time_slot: "2025-05-11  7:30:00 AM",
          },
          {
            timestamp: 1746964800,
            time_slot: "2025-05-11  8:00:00 AM",
          },
          {
            timestamp: 1746966600,
            time_slot: "2025-05-11  8:30:00 AM",
          },
          {
            timestamp: 1746968400,
            time_slot: "2025-05-11  9:00:00 AM",
          },
          {
            timestamp: 1746970200,
            time_slot: "2025-05-11  9:30:00 AM",
          },
          {
            timestamp: 1746972000,
            time_slot: "2025-05-11 10:00:00 AM",
          },
          {
            timestamp: 1746973800,
            time_slot: "2025-05-11 10:30:00 AM",
          },
          {
            timestamp: 1746975600,
            time_slot: "2025-05-11 11:00:00 AM",
          },
          {
            timestamp: 1746977400,
            time_slot: "2025-05-11 11:30:00 AM",
          },
          {
            timestamp: 1746979200,
            time_slot: "2025-05-11 12:00:00 PM",
          },
          {
            timestamp: 1746981000,
            time_slot: "2025-05-11 12:30:00 PM",
          },
          {
            timestamp: 1746982800,
            time_slot: "2025-05-11  1:00:00 PM",
          },
          {
            timestamp: 1746984600,
            time_slot: "2025-05-11  1:30:00 PM",
          },
          {
            timestamp: 1746986400,
            time_slot: "2025-05-11  2:00:00 PM",
          },
          {
            timestamp: 1746988200,
            time_slot: "2025-05-11  2:30:00 PM",
          },
          {
            timestamp: 1746990000,
            time_slot: "2025-05-11  3:00:00 PM",
          },
          {
            timestamp: 1746991800,
            time_slot: "2025-05-11  3:30:00 PM",
          },
          {
            timestamp: 1746993600,
            time_slot: "2025-05-11  4:00:00 PM",
          },
          {
            timestamp: 1746995400,
            time_slot: "2025-05-11  4:30:00 PM",
          },
          {
            timestamp: 1746997200,
            time_slot: "2025-05-11  5:00:00 PM",
          },
          {
            timestamp: 1747054800,
            time_slot: "2025-05-12  9:00:00 AM",
          },
          {
            timestamp: 1747056600,
            time_slot: "2025-05-12  9:30:00 AM",
          },
          {
            timestamp: 1747058400,
            time_slot: "2025-05-12 10:00:00 AM",
          },
          {
            timestamp: 1747060200,
            time_slot: "2025-05-12 10:30:00 AM",
          },
          {
            timestamp: 1747062000,
            time_slot: "2025-05-12 11:00:00 AM",
          },
          {
            timestamp: 1747063800,
            time_slot: "2025-05-12 11:30:00 AM",
          },
          {
            timestamp: 1747065600,
            time_slot: "2025-05-12 12:00:00 PM",
          },
          {
            timestamp: 1747067400,
            time_slot: "2025-05-12 12:30:00 PM",
          },
          {
            timestamp: 1747069200,
            time_slot: "2025-05-12  1:00:00 PM",
          },
          {
            timestamp: 1747071000,
            time_slot: "2025-05-12  1:30:00 PM",
          },
          {
            timestamp: 1747072800,
            time_slot: "2025-05-12  2:00:00 PM",
          },
          {
            timestamp: 1747074600,
            time_slot: "2025-05-12  2:30:00 PM",
          },
          {
            timestamp: 1747076400,
            time_slot: "2025-05-12  3:00:00 PM",
          },
          {
            timestamp: 1747078200,
            time_slot: "2025-05-12  3:30:00 PM",
          },
          {
            timestamp: 1747080000,
            time_slot: "2025-05-12  4:00:00 PM",
          },
          {
            timestamp: 1747137600,
            time_slot: "2025-05-13  8:00:00 AM",
          },
          {
            timestamp: 1747139400,
            time_slot: "2025-05-13  8:30:00 AM",
          },
          {
            timestamp: 1747141200,
            time_slot: "2025-05-13  9:00:00 AM",
          },
          {
            timestamp: 1747143000,
            time_slot: "2025-05-13  9:30:00 AM",
          },
          {
            timestamp: 1747144800,
            time_slot: "2025-05-13 10:00:00 AM",
          },
          {
            timestamp: 1747146600,
            time_slot: "2025-05-13 10:30:00 AM",
          },
          {
            timestamp: 1747148400,
            time_slot: "2025-05-13 11:00:00 AM",
          },
          {
            timestamp: 1747150200,
            time_slot: "2025-05-13 11:30:00 AM",
          },
          {
            timestamp: 1747152000,
            time_slot: "2025-05-13 12:00:00 PM",
          },
          {
            timestamp: 1747153800,
            time_slot: "2025-05-13 12:30:00 PM",
          },
          {
            timestamp: 1747155600,
            time_slot: "2025-05-13  1:00:00 PM",
          },
          {
            timestamp: 1747157400,
            time_slot: "2025-05-13  1:30:00 PM",
          },
          {
            timestamp: 1747159200,
            time_slot: "2025-05-13  2:00:00 PM",
          },
          {
            timestamp: 1747161000,
            time_slot: "2025-05-13  2:30:00 PM",
          },
          {
            timestamp: 1747162800,
            time_slot: "2025-05-13  3:00:00 PM",
          },
          {
            timestamp: 1747164600,
            time_slot: "2025-05-13  3:30:00 PM",
          },
          {
            timestamp: 1747166400,
            time_slot: "2025-05-13  4:00:00 PM",
          },
          {
            timestamp: 1747168200,
            time_slot: "2025-05-13  4:30:00 PM",
          },
          {
            timestamp: 1747170000,
            time_slot: "2025-05-13  5:00:00 PM",
          },
          {
            timestamp: 1747224000,
            time_slot: "2025-05-14  8:00:00 AM",
          },
          {
            timestamp: 1747225800,
            time_slot: "2025-05-14  8:30:00 AM",
          },
          {
            timestamp: 1747227600,
            time_slot: "2025-05-14  9:00:00 AM",
          },
          {
            timestamp: 1747229400,
            time_slot: "2025-05-14  9:30:00 AM",
          },
          {
            timestamp: 1747231200,
            time_slot: "2025-05-14 10:00:00 AM",
          },
          {
            timestamp: 1747233000,
            time_slot: "2025-05-14 10:30:00 AM",
          },
          {
            timestamp: 1747234800,
            time_slot: "2025-05-14 11:00:00 AM",
          },
          {
            timestamp: 1747236600,
            time_slot: "2025-05-14 11:30:00 AM",
          },
          {
            timestamp: 1747238400,
            time_slot: "2025-05-14 12:00:00 PM",
          },
          {
            timestamp: 1747240200,
            time_slot: "2025-05-14 12:30:00 PM",
          },
          {
            timestamp: 1747242000,
            time_slot: "2025-05-14  1:00:00 PM",
          },
          {
            timestamp: 1747243800,
            time_slot: "2025-05-14  1:30:00 PM",
          },
          {
            timestamp: 1747245600,
            time_slot: "2025-05-14  2:00:00 PM",
          },
          {
            timestamp: 1747247400,
            time_slot: "2025-05-14  2:30:00 PM",
          },
          {
            timestamp: 1747249200,
            time_slot: "2025-05-14  3:00:00 PM",
          },
          {
            timestamp: 1747251000,
            time_slot: "2025-05-14  3:30:00 PM",
          },
          {
            timestamp: 1747252800,
            time_slot: "2025-05-14  4:00:00 PM",
          },
          {
            timestamp: 1747310400,
            time_slot: "2025-05-15  8:00:00 AM",
          },
          {
            timestamp: 1747312200,
            time_slot: "2025-05-15  8:30:00 AM",
          },
          {
            timestamp: 1747314000,
            time_slot: "2025-05-15  9:00:00 AM",
          },
          {
            timestamp: 1747315800,
            time_slot: "2025-05-15  9:30:00 AM",
          },
          {
            timestamp: 1747317600,
            time_slot: "2025-05-15 10:00:00 AM",
          },
          {
            timestamp: 1747319400,
            time_slot: "2025-05-15 10:30:00 AM",
          },
          {
            timestamp: 1747321200,
            time_slot: "2025-05-15 11:00:00 AM",
          },
          {
            timestamp: 1747323000,
            time_slot: "2025-05-15 11:30:00 AM",
          },
          {
            timestamp: 1747324800,
            time_slot: "2025-05-15 12:00:00 PM",
          },
          {
            timestamp: 1747326600,
            time_slot: "2025-05-15 12:30:00 PM",
          },
          {
            timestamp: 1747328400,
            time_slot: "2025-05-15  1:00:00 PM",
          },
          {
            timestamp: 1747330200,
            time_slot: "2025-05-15  1:30:00 PM",
          },
          {
            timestamp: 1747332000,
            time_slot: "2025-05-15  2:00:00 PM",
          },
          {
            timestamp: 1747333800,
            time_slot: "2025-05-15  2:30:00 PM",
          },
          {
            timestamp: 1747335600,
            time_slot: "2025-05-15  3:00:00 PM",
          },
          {
            timestamp: 1747337400,
            time_slot: "2025-05-15  3:30:00 PM",
          },
          {
            timestamp: 1747339200,
            time_slot: "2025-05-15  4:00:00 PM",
          },
          {
            timestamp: 1747341000,
            time_slot: "2025-05-15  4:30:00 PM",
          },
          {
            timestamp: 1747342800,
            time_slot: "2025-05-15  5:00:00 PM",
          },
          {
            timestamp: 1747479600,
            time_slot: "2025-05-17  7:00:00 AM",
          },
          {
            timestamp: 1747481400,
            time_slot: "2025-05-17  7:30:00 AM",
          },
          {
            timestamp: 1747483200,
            time_slot: "2025-05-17  8:00:00 AM",
          },
          {
            timestamp: 1747485000,
            time_slot: "2025-05-17  8:30:00 AM",
          },
          {
            timestamp: 1747486800,
            time_slot: "2025-05-17  9:00:00 AM",
          },
          {
            timestamp: 1747488600,
            time_slot: "2025-05-17  9:30:00 AM",
          },
          {
            timestamp: 1747490400,
            time_slot: "2025-05-17 10:00:00 AM",
          },
          {
            timestamp: 1747492200,
            time_slot: "2025-05-17 10:30:00 AM",
          },
          {
            timestamp: 1747494000,
            time_slot: "2025-05-17 11:00:00 AM",
          },
          {
            timestamp: 1747495800,
            time_slot: "2025-05-17 11:30:00 AM",
          },
          {
            timestamp: 1747499400,
            time_slot: "2025-05-17 12:30:00 PM",
          },
          {
            timestamp: 1747501200,
            time_slot: "2025-05-17  1:00:00 PM",
          },
          {
            timestamp: 1747503000,
            time_slot: "2025-05-17  1:30:00 PM",
          },
          {
            timestamp: 1747504800,
            time_slot: "2025-05-17  2:00:00 PM",
          },
          {
            timestamp: 1747506600,
            time_slot: "2025-05-17  2:30:00 PM",
          },
          {
            timestamp: 1747508400,
            time_slot: "2025-05-17  3:00:00 PM",
          },
          {
            timestamp: 1747557000,
            time_slot: "2025-05-18  4:30:00 AM",
          },
          {
            timestamp: 1747558800,
            time_slot: "2025-05-18  5:00:00 AM",
          },
          {
            timestamp: 1747560600,
            time_slot: "2025-05-18  5:30:00 AM",
          },
          {
            timestamp: 1747562400,
            time_slot: "2025-05-18  6:00:00 AM",
          },
          {
            timestamp: 1747564200,
            time_slot: "2025-05-18  6:30:00 AM",
          },
          {
            timestamp: 1747566000,
            time_slot: "2025-05-18  7:00:00 AM",
          },
          {
            timestamp: 1747567800,
            time_slot: "2025-05-18  7:30:00 AM",
          },
          {
            timestamp: 1747569600,
            time_slot: "2025-05-18  8:00:00 AM",
          },
          {
            timestamp: 1747571400,
            time_slot: "2025-05-18  8:30:00 AM",
          },
          {
            timestamp: 1747573200,
            time_slot: "2025-05-18  9:00:00 AM",
          },
          {
            timestamp: 1747575000,
            time_slot: "2025-05-18  9:30:00 AM",
          },
          {
            timestamp: 1747576800,
            time_slot: "2025-05-18 10:00:00 AM",
          },
          {
            timestamp: 1747578600,
            time_slot: "2025-05-18 10:30:00 AM",
          },
          {
            timestamp: 1747580400,
            time_slot: "2025-05-18 11:00:00 AM",
          },
          {
            timestamp: 1747582200,
            time_slot: "2025-05-18 11:30:00 AM",
          },
          {
            timestamp: 1747584000,
            time_slot: "2025-05-18 12:00:00 PM",
          },
          {
            timestamp: 1747585800,
            time_slot: "2025-05-18 12:30:00 PM",
          },
          {
            timestamp: 1747587600,
            time_slot: "2025-05-18  1:00:00 PM",
          },
          {
            timestamp: 1747589400,
            time_slot: "2025-05-18  1:30:00 PM",
          },
          {
            timestamp: 1747591200,
            time_slot: "2025-05-18  2:00:00 PM",
          },
          {
            timestamp: 1747593000,
            time_slot: "2025-05-18  2:30:00 PM",
          },
          {
            timestamp: 1747594800,
            time_slot: "2025-05-18  3:00:00 PM",
          },
          {
            timestamp: 1747596600,
            time_slot: "2025-05-18  3:30:00 PM",
          },
          {
            timestamp: 1747598400,
            time_slot: "2025-05-18  4:00:00 PM",
          },
          {
            timestamp: 1747600200,
            time_slot: "2025-05-18  4:30:00 PM",
          },
          {
            timestamp: 1747602000,
            time_slot: "2025-05-18  5:00:00 PM",
          },
          {
            timestamp: 1747659600,
            time_slot: "2025-05-19  9:00:00 AM",
          },
          {
            timestamp: 1747661400,
            time_slot: "2025-05-19  9:30:00 AM",
          },
          {
            timestamp: 1747663200,
            time_slot: "2025-05-19 10:00:00 AM",
          },
          {
            timestamp: 1747665000,
            time_slot: "2025-05-19 10:30:00 AM",
          },
          {
            timestamp: 1747666800,
            time_slot: "2025-05-19 11:00:00 AM",
          },
          {
            timestamp: 1747668600,
            time_slot: "2025-05-19 11:30:00 AM",
          },
          {
            timestamp: 1747670400,
            time_slot: "2025-05-19 12:00:00 PM",
          },
          {
            timestamp: 1747672200,
            time_slot: "2025-05-19 12:30:00 PM",
          },
          {
            timestamp: 1747674000,
            time_slot: "2025-05-19  1:00:00 PM",
          },
          {
            timestamp: 1747675800,
            time_slot: "2025-05-19  1:30:00 PM",
          },
          {
            timestamp: 1747677600,
            time_slot: "2025-05-19  2:00:00 PM",
          },
          {
            timestamp: 1747679400,
            time_slot: "2025-05-19  2:30:00 PM",
          },
          {
            timestamp: 1747681200,
            time_slot: "2025-05-19  3:00:00 PM",
          },
          {
            timestamp: 1747683000,
            time_slot: "2025-05-19  3:30:00 PM",
          },
          {
            timestamp: 1747684800,
            time_slot: "2025-05-19  4:00:00 PM",
          },
          {
            timestamp: 1747742400,
            time_slot: "2025-05-20  8:00:00 AM",
          },
          {
            timestamp: 1747744200,
            time_slot: "2025-05-20  8:30:00 AM",
          },
          {
            timestamp: 1747746000,
            time_slot: "2025-05-20  9:00:00 AM",
          },
          {
            timestamp: 1747747800,
            time_slot: "2025-05-20  9:30:00 AM",
          },
          {
            timestamp: 1747749600,
            time_slot: "2025-05-20 10:00:00 AM",
          },
          {
            timestamp: 1747751400,
            time_slot: "2025-05-20 10:30:00 AM",
          },
          {
            timestamp: 1747753200,
            time_slot: "2025-05-20 11:00:00 AM",
          },
          {
            timestamp: 1747755000,
            time_slot: "2025-05-20 11:30:00 AM",
          },
          {
            timestamp: 1747756800,
            time_slot: "2025-05-20 12:00:00 PM",
          },
          {
            timestamp: 1747758600,
            time_slot: "2025-05-20 12:30:00 PM",
          },
          {
            timestamp: 1747760400,
            time_slot: "2025-05-20  1:00:00 PM",
          },
          {
            timestamp: 1747762200,
            time_slot: "2025-05-20  1:30:00 PM",
          },
          {
            timestamp: 1747764000,
            time_slot: "2025-05-20  2:00:00 PM",
          },
          {
            timestamp: 1747765800,
            time_slot: "2025-05-20  2:30:00 PM",
          },
          {
            timestamp: 1747767600,
            time_slot: "2025-05-20  3:00:00 PM",
          },
          {
            timestamp: 1747769400,
            time_slot: "2025-05-20  3:30:00 PM",
          },
          {
            timestamp: 1747771200,
            time_slot: "2025-05-20  4:00:00 PM",
          },
          {
            timestamp: 1747773000,
            time_slot: "2025-05-20  4:30:00 PM",
          },
          {
            timestamp: 1747774800,
            time_slot: "2025-05-20  5:00:00 PM",
          },
          {
            timestamp: 1747828800,
            time_slot: "2025-05-21  8:00:00 AM",
          },
          {
            timestamp: 1747830600,
            time_slot: "2025-05-21  8:30:00 AM",
          },
          {
            timestamp: 1747832400,
            time_slot: "2025-05-21  9:00:00 AM",
          },
          {
            timestamp: 1747834200,
            time_slot: "2025-05-21  9:30:00 AM",
          },
          {
            timestamp: 1747836000,
            time_slot: "2025-05-21 10:00:00 AM",
          },
          {
            timestamp: 1747837800,
            time_slot: "2025-05-21 10:30:00 AM",
          },
          {
            timestamp: 1747839600,
            time_slot: "2025-05-21 11:00:00 AM",
          },
          {
            timestamp: 1747841400,
            time_slot: "2025-05-21 11:30:00 AM",
          },
          {
            timestamp: 1747843200,
            time_slot: "2025-05-21 12:00:00 PM",
          },
          {
            timestamp: 1747845000,
            time_slot: "2025-05-21 12:30:00 PM",
          },
          {
            timestamp: 1747846800,
            time_slot: "2025-05-21  1:00:00 PM",
          },
          {
            timestamp: 1747848600,
            time_slot: "2025-05-21  1:30:00 PM",
          },
          {
            timestamp: 1747850400,
            time_slot: "2025-05-21  2:00:00 PM",
          },
          {
            timestamp: 1747852200,
            time_slot: "2025-05-21  2:30:00 PM",
          },
          {
            timestamp: 1747854000,
            time_slot: "2025-05-21  3:00:00 PM",
          },
          {
            timestamp: 1747855800,
            time_slot: "2025-05-21  3:30:00 PM",
          },
          {
            timestamp: 1747857600,
            time_slot: "2025-05-21  4:00:00 PM",
          },
          {
            timestamp: 1747915200,
            time_slot: "2025-05-22  8:00:00 AM",
          },
          {
            timestamp: 1747917000,
            time_slot: "2025-05-22  8:30:00 AM",
          },
          {
            timestamp: 1747918800,
            time_slot: "2025-05-22  9:00:00 AM",
          },
          {
            timestamp: 1747920600,
            time_slot: "2025-05-22  9:30:00 AM",
          },
          {
            timestamp: 1747922400,
            time_slot: "2025-05-22 10:00:00 AM",
          },
          {
            timestamp: 1747924200,
            time_slot: "2025-05-22 10:30:00 AM",
          },
          {
            timestamp: 1747926000,
            time_slot: "2025-05-22 11:00:00 AM",
          },
          {
            timestamp: 1747927800,
            time_slot: "2025-05-22 11:30:00 AM",
          },
          {
            timestamp: 1747929600,
            time_slot: "2025-05-22 12:00:00 PM",
          },
          {
            timestamp: 1747931400,
            time_slot: "2025-05-22 12:30:00 PM",
          },
          {
            timestamp: 1747933200,
            time_slot: "2025-05-22  1:00:00 PM",
          },
          {
            timestamp: 1747935000,
            time_slot: "2025-05-22  1:30:00 PM",
          },
          {
            timestamp: 1747936800,
            time_slot: "2025-05-22  2:00:00 PM",
          },
          {
            timestamp: 1747938600,
            time_slot: "2025-05-22  2:30:00 PM",
          },
          {
            timestamp: 1747940400,
            time_slot: "2025-05-22  3:00:00 PM",
          },
          {
            timestamp: 1747942200,
            time_slot: "2025-05-22  3:30:00 PM",
          },
          {
            timestamp: 1747944000,
            time_slot: "2025-05-22  4:00:00 PM",
          },
          {
            timestamp: 1747945800,
            time_slot: "2025-05-22  4:30:00 PM",
          },
          {
            timestamp: 1747947600,
            time_slot: "2025-05-22  5:00:00 PM",
          },
          {
            timestamp: 1748084400,
            time_slot: "2025-05-24  7:00:00 AM",
          },
          {
            timestamp: 1748086200,
            time_slot: "2025-05-24  7:30:00 AM",
          },
          {
            timestamp: 1748088000,
            time_slot: "2025-05-24  8:00:00 AM",
          },
          {
            timestamp: 1748089800,
            time_slot: "2025-05-24  8:30:00 AM",
          },
          {
            timestamp: 1748091600,
            time_slot: "2025-05-24  9:00:00 AM",
          },
          {
            timestamp: 1748093400,
            time_slot: "2025-05-24  9:30:00 AM",
          },
          {
            timestamp: 1748095200,
            time_slot: "2025-05-24 10:00:00 AM",
          },
          {
            timestamp: 1748097000,
            time_slot: "2025-05-24 10:30:00 AM",
          },
          {
            timestamp: 1748098800,
            time_slot: "2025-05-24 11:00:00 AM",
          },
          {
            timestamp: 1748100600,
            time_slot: "2025-05-24 11:30:00 AM",
          },
          {
            timestamp: 1748104200,
            time_slot: "2025-05-24 12:30:00 PM",
          },
          {
            timestamp: 1748106000,
            time_slot: "2025-05-24  1:00:00 PM",
          },
          {
            timestamp: 1748107800,
            time_slot: "2025-05-24  1:30:00 PM",
          },
          {
            timestamp: 1748109600,
            time_slot: "2025-05-24  2:00:00 PM",
          },
          {
            timestamp: 1748111400,
            time_slot: "2025-05-24  2:30:00 PM",
          },
          {
            timestamp: 1748113200,
            time_slot: "2025-05-24  3:00:00 PM",
          },
          {
            timestamp: 1748161800,
            time_slot: "2025-05-25  4:30:00 AM",
          },
          {
            timestamp: 1748163600,
            time_slot: "2025-05-25  5:00:00 AM",
          },
          {
            timestamp: 1748165400,
            time_slot: "2025-05-25  5:30:00 AM",
          },
          {
            timestamp: 1748167200,
            time_slot: "2025-05-25  6:00:00 AM",
          },
          {
            timestamp: 1748169000,
            time_slot: "2025-05-25  6:30:00 AM",
          },
          {
            timestamp: 1748170800,
            time_slot: "2025-05-25  7:00:00 AM",
          },
          {
            timestamp: 1748172600,
            time_slot: "2025-05-25  7:30:00 AM",
          },
          {
            timestamp: 1748174400,
            time_slot: "2025-05-25  8:00:00 AM",
          },
          {
            timestamp: 1748176200,
            time_slot: "2025-05-25  8:30:00 AM",
          },
          {
            timestamp: 1748178000,
            time_slot: "2025-05-25  9:00:00 AM",
          },
          {
            timestamp: 1748179800,
            time_slot: "2025-05-25  9:30:00 AM",
          },
          {
            timestamp: 1748181600,
            time_slot: "2025-05-25 10:00:00 AM",
          },
          {
            timestamp: 1748183400,
            time_slot: "2025-05-25 10:30:00 AM",
          },
          {
            timestamp: 1748185200,
            time_slot: "2025-05-25 11:00:00 AM",
          },
          {
            timestamp: 1748187000,
            time_slot: "2025-05-25 11:30:00 AM",
          },
          {
            timestamp: 1748188800,
            time_slot: "2025-05-25 12:00:00 PM",
          },
          {
            timestamp: 1748190600,
            time_slot: "2025-05-25 12:30:00 PM",
          },
          {
            timestamp: 1748192400,
            time_slot: "2025-05-25  1:00:00 PM",
          },
          {
            timestamp: 1748194200,
            time_slot: "2025-05-25  1:30:00 PM",
          },
          {
            timestamp: 1748196000,
            time_slot: "2025-05-25  2:00:00 PM",
          },
          {
            timestamp: 1748197800,
            time_slot: "2025-05-25  2:30:00 PM",
          },
          {
            timestamp: 1748199600,
            time_slot: "2025-05-25  3:00:00 PM",
          },
          {
            timestamp: 1748201400,
            time_slot: "2025-05-25  3:30:00 PM",
          },
          {
            timestamp: 1748203200,
            time_slot: "2025-05-25  4:00:00 PM",
          },
          {
            timestamp: 1748205000,
            time_slot: "2025-05-25  4:30:00 PM",
          },
          {
            timestamp: 1748206800,
            time_slot: "2025-05-25  5:00:00 PM",
          },
          {
            timestamp: 1748264400,
            time_slot: "2025-05-26  9:00:00 AM",
          },
          {
            timestamp: 1748266200,
            time_slot: "2025-05-26  9:30:00 AM",
          },
          {
            timestamp: 1748268000,
            time_slot: "2025-05-26 10:00:00 AM",
          },
          {
            timestamp: 1748269800,
            time_slot: "2025-05-26 10:30:00 AM",
          },
          {
            timestamp: 1748271600,
            time_slot: "2025-05-26 11:00:00 AM",
          },
          {
            timestamp: 1748273400,
            time_slot: "2025-05-26 11:30:00 AM",
          },
          {
            timestamp: 1748275200,
            time_slot: "2025-05-26 12:00:00 PM",
          },
          {
            timestamp: 1748277000,
            time_slot: "2025-05-26 12:30:00 PM",
          },
          {
            timestamp: 1748278800,
            time_slot: "2025-05-26  1:00:00 PM",
          },
          {
            timestamp: 1748280600,
            time_slot: "2025-05-26  1:30:00 PM",
          },
          {
            timestamp: 1748282400,
            time_slot: "2025-05-26  2:00:00 PM",
          },
          {
            timestamp: 1748284200,
            time_slot: "2025-05-26  2:30:00 PM",
          },
          {
            timestamp: 1748286000,
            time_slot: "2025-05-26  3:00:00 PM",
          },
          {
            timestamp: 1748287800,
            time_slot: "2025-05-26  3:30:00 PM",
          },
          {
            timestamp: 1748289600,
            time_slot: "2025-05-26  4:00:00 PM",
          },
          {
            timestamp: 1748347200,
            time_slot: "2025-05-27  8:00:00 AM",
          },
          {
            timestamp: 1748349000,
            time_slot: "2025-05-27  8:30:00 AM",
          },
          {
            timestamp: 1748350800,
            time_slot: "2025-05-27  9:00:00 AM",
          },
          {
            timestamp: 1748352600,
            time_slot: "2025-05-27  9:30:00 AM",
          },
          {
            timestamp: 1748354400,
            time_slot: "2025-05-27 10:00:00 AM",
          },
          {
            timestamp: 1748356200,
            time_slot: "2025-05-27 10:30:00 AM",
          },
          {
            timestamp: 1748358000,
            time_slot: "2025-05-27 11:00:00 AM",
          },
          {
            timestamp: 1748359800,
            time_slot: "2025-05-27 11:30:00 AM",
          },
          {
            timestamp: 1748361600,
            time_slot: "2025-05-27 12:00:00 PM",
          },
          {
            timestamp: 1748363400,
            time_slot: "2025-05-27 12:30:00 PM",
          },
          {
            timestamp: 1748365200,
            time_slot: "2025-05-27  1:00:00 PM",
          },
          {
            timestamp: 1748367000,
            time_slot: "2025-05-27  1:30:00 PM",
          },
          {
            timestamp: 1748368800,
            time_slot: "2025-05-27  2:00:00 PM",
          },
          {
            timestamp: 1748370600,
            time_slot: "2025-05-27  2:30:00 PM",
          },
          {
            timestamp: 1748372400,
            time_slot: "2025-05-27  3:00:00 PM",
          },
          {
            timestamp: 1748374200,
            time_slot: "2025-05-27  3:30:00 PM",
          },
          {
            timestamp: 1748376000,
            time_slot: "2025-05-27  4:00:00 PM",
          },
          {
            timestamp: 1748377800,
            time_slot: "2025-05-27  4:30:00 PM",
          },
          {
            timestamp: 1748379600,
            time_slot: "2025-05-27  5:00:00 PM",
          },
          {
            timestamp: 1748433600,
            time_slot: "2025-05-28  8:00:00 AM",
          },
          {
            timestamp: 1748435400,
            time_slot: "2025-05-28  8:30:00 AM",
          },
          {
            timestamp: 1748437200,
            time_slot: "2025-05-28  9:00:00 AM",
          },
          {
            timestamp: 1748439000,
            time_slot: "2025-05-28  9:30:00 AM",
          },
          {
            timestamp: 1748440800,
            time_slot: "2025-05-28 10:00:00 AM",
          },
          {
            timestamp: 1748442600,
            time_slot: "2025-05-28 10:30:00 AM",
          },
          {
            timestamp: 1748444400,
            time_slot: "2025-05-28 11:00:00 AM",
          },
          {
            timestamp: 1748446200,
            time_slot: "2025-05-28 11:30:00 AM",
          },
          {
            timestamp: 1748448000,
            time_slot: "2025-05-28 12:00:00 PM",
          },
          {
            timestamp: 1748449800,
            time_slot: "2025-05-28 12:30:00 PM",
          },
          {
            timestamp: 1748451600,
            time_slot: "2025-05-28  1:00:00 PM",
          },
          {
            timestamp: 1748453400,
            time_slot: "2025-05-28  1:30:00 PM",
          },
          {
            timestamp: 1748455200,
            time_slot: "2025-05-28  2:00:00 PM",
          },
          {
            timestamp: 1748457000,
            time_slot: "2025-05-28  2:30:00 PM",
          },
          {
            timestamp: 1748458800,
            time_slot: "2025-05-28  3:00:00 PM",
          },
          {
            timestamp: 1748460600,
            time_slot: "2025-05-28  3:30:00 PM",
          },
          {
            timestamp: 1748462400,
            time_slot: "2025-05-28  4:00:00 PM",
          },
          {
            timestamp: 1748520000,
            time_slot: "2025-05-29  8:00:00 AM",
          },
          {
            timestamp: 1748521800,
            time_slot: "2025-05-29  8:30:00 AM",
          },
          {
            timestamp: 1748523600,
            time_slot: "2025-05-29  9:00:00 AM",
          },
          {
            timestamp: 1748525400,
            time_slot: "2025-05-29  9:30:00 AM",
          },
          {
            timestamp: 1748527200,
            time_slot: "2025-05-29 10:00:00 AM",
          },
          {
            timestamp: 1748529000,
            time_slot: "2025-05-29 10:30:00 AM",
          },
          {
            timestamp: 1748530800,
            time_slot: "2025-05-29 11:00:00 AM",
          },
          {
            timestamp: 1748532600,
            time_slot: "2025-05-29 11:30:00 AM",
          },
          {
            timestamp: 1748534400,
            time_slot: "2025-05-29 12:00:00 PM",
          },
          {
            timestamp: 1748536200,
            time_slot: "2025-05-29 12:30:00 PM",
          },
          {
            timestamp: 1748538000,
            time_slot: "2025-05-29  1:00:00 PM",
          },
          {
            timestamp: 1748539800,
            time_slot: "2025-05-29  1:30:00 PM",
          },
          {
            timestamp: 1748541600,
            time_slot: "2025-05-29  2:00:00 PM",
          },
          {
            timestamp: 1748543400,
            time_slot: "2025-05-29  2:30:00 PM",
          },
          {
            timestamp: 1748545200,
            time_slot: "2025-05-29  3:00:00 PM",
          },
          {
            timestamp: 1748547000,
            time_slot: "2025-05-29  3:30:00 PM",
          },
          {
            timestamp: 1748548800,
            time_slot: "2025-05-29  4:00:00 PM",
          },
          {
            timestamp: 1748550600,
            time_slot: "2025-05-29  4:30:00 PM",
          },
          {
            timestamp: 1748552400,
            time_slot: "2025-05-29  5:00:00 PM",
          },
          {
            timestamp: 1748689200,
            time_slot: "2025-05-31  7:00:00 AM",
          },
          {
            timestamp: 1748691000,
            time_slot: "2025-05-31  7:30:00 AM",
          },
          {
            timestamp: 1748692800,
            time_slot: "2025-05-31  8:00:00 AM",
          },
          {
            timestamp: 1748694600,
            time_slot: "2025-05-31  8:30:00 AM",
          },
          {
            timestamp: 1748696400,
            time_slot: "2025-05-31  9:00:00 AM",
          },
          {
            timestamp: 1748698200,
            time_slot: "2025-05-31  9:30:00 AM",
          },
          {
            timestamp: 1748700000,
            time_slot: "2025-05-31 10:00:00 AM",
          },
          {
            timestamp: 1748701800,
            time_slot: "2025-05-31 10:30:00 AM",
          },
          {
            timestamp: 1748703600,
            time_slot: "2025-05-31 11:00:00 AM",
          },
          {
            timestamp: 1748705400,
            time_slot: "2025-05-31 11:30:00 AM",
          },
          {
            timestamp: 1748709000,
            time_slot: "2025-05-31 12:30:00 PM",
          },
          {
            timestamp: 1748710800,
            time_slot: "2025-05-31  1:00:00 PM",
          },
          {
            timestamp: 1748712600,
            time_slot: "2025-05-31  1:30:00 PM",
          },
          {
            timestamp: 1748714400,
            time_slot: "2025-05-31  2:00:00 PM",
          },
          {
            timestamp: 1748716200,
            time_slot: "2025-05-31  2:30:00 PM",
          },
          {
            timestamp: 1748718000,
            time_slot: "2025-05-31  3:00:00 PM",
          },
          {
            timestamp: 1748766600,
            time_slot: "2025-06-01  4:30:00 AM",
          },
          {
            timestamp: 1748768400,
            time_slot: "2025-06-01  5:00:00 AM",
          },
          {
            timestamp: 1748770200,
            time_slot: "2025-06-01  5:30:00 AM",
          },
          {
            timestamp: 1748772000,
            time_slot: "2025-06-01  6:00:00 AM",
          },
          {
            timestamp: 1748773800,
            time_slot: "2025-06-01  6:30:00 AM",
          },
          {
            timestamp: 1748775600,
            time_slot: "2025-06-01  7:00:00 AM",
          },
          {
            timestamp: 1748777400,
            time_slot: "2025-06-01  7:30:00 AM",
          },
          {
            timestamp: 1748779200,
            time_slot: "2025-06-01  8:00:00 AM",
          },
          {
            timestamp: 1748781000,
            time_slot: "2025-06-01  8:30:00 AM",
          },
          {
            timestamp: 1748782800,
            time_slot: "2025-06-01  9:00:00 AM",
          },
          {
            timestamp: 1748784600,
            time_slot: "2025-06-01  9:30:00 AM",
          },
          {
            timestamp: 1748786400,
            time_slot: "2025-06-01 10:00:00 AM",
          },
          {
            timestamp: 1748788200,
            time_slot: "2025-06-01 10:30:00 AM",
          },
          {
            timestamp: 1748790000,
            time_slot: "2025-06-01 11:00:00 AM",
          },
          {
            timestamp: 1748791800,
            time_slot: "2025-06-01 11:30:00 AM",
          },
          {
            timestamp: 1748793600,
            time_slot: "2025-06-01 12:00:00 PM",
          },
          {
            timestamp: 1748795400,
            time_slot: "2025-06-01 12:30:00 PM",
          },
          {
            timestamp: 1748797200,
            time_slot: "2025-06-01  1:00:00 PM",
          },
          {
            timestamp: 1748799000,
            time_slot: "2025-06-01  1:30:00 PM",
          },
          {
            timestamp: 1748800800,
            time_slot: "2025-06-01  2:00:00 PM",
          },
          {
            timestamp: 1748802600,
            time_slot: "2025-06-01  2:30:00 PM",
          },
          {
            timestamp: 1748804400,
            time_slot: "2025-06-01  3:00:00 PM",
          },
          {
            timestamp: 1748806200,
            time_slot: "2025-06-01  3:30:00 PM",
          },
          {
            timestamp: 1748808000,
            time_slot: "2025-06-01  4:00:00 PM",
          },
          {
            timestamp: 1748809800,
            time_slot: "2025-06-01  4:30:00 PM",
          },
          {
            timestamp: 1748811600,
            time_slot: "2025-06-01  5:00:00 PM",
          },
          {
            timestamp: 1748869200,
            time_slot: "2025-06-02  9:00:00 AM",
          },
          {
            timestamp: 1748871000,
            time_slot: "2025-06-02  9:30:00 AM",
          },
          {
            timestamp: 1748872800,
            time_slot: "2025-06-02 10:00:00 AM",
          },
          {
            timestamp: 1748874600,
            time_slot: "2025-06-02 10:30:00 AM",
          },
          {
            timestamp: 1748876400,
            time_slot: "2025-06-02 11:00:00 AM",
          },
          {
            timestamp: 1748878200,
            time_slot: "2025-06-02 11:30:00 AM",
          },
          {
            timestamp: 1748880000,
            time_slot: "2025-06-02 12:00:00 PM",
          },
          {
            timestamp: 1748881800,
            time_slot: "2025-06-02 12:30:00 PM",
          },
          {
            timestamp: 1748883600,
            time_slot: "2025-06-02  1:00:00 PM",
          },
          {
            timestamp: 1748885400,
            time_slot: "2025-06-02  1:30:00 PM",
          },
          {
            timestamp: 1748887200,
            time_slot: "2025-06-02  2:00:00 PM",
          },
          {
            timestamp: 1748889000,
            time_slot: "2025-06-02  2:30:00 PM",
          },
          {
            timestamp: 1748890800,
            time_slot: "2025-06-02  3:00:00 PM",
          },
          {
            timestamp: 1748892600,
            time_slot: "2025-06-02  3:30:00 PM",
          },
          {
            timestamp: 1748894400,
            time_slot: "2025-06-02  4:00:00 PM",
          },
          {
            timestamp: 1748952000,
            time_slot: "2025-06-03  8:00:00 AM",
          },
          {
            timestamp: 1748953800,
            time_slot: "2025-06-03  8:30:00 AM",
          },
          {
            timestamp: 1748955600,
            time_slot: "2025-06-03  9:00:00 AM",
          },
          {
            timestamp: 1748957400,
            time_slot: "2025-06-03  9:30:00 AM",
          },
          {
            timestamp: 1748959200,
            time_slot: "2025-06-03 10:00:00 AM",
          },
          {
            timestamp: 1748961000,
            time_slot: "2025-06-03 10:30:00 AM",
          },
          {
            timestamp: 1748962800,
            time_slot: "2025-06-03 11:00:00 AM",
          },
          {
            timestamp: 1748964600,
            time_slot: "2025-06-03 11:30:00 AM",
          },
          {
            timestamp: 1748966400,
            time_slot: "2025-06-03 12:00:00 PM",
          },
          {
            timestamp: 1748968200,
            time_slot: "2025-06-03 12:30:00 PM",
          },
          {
            timestamp: 1748970000,
            time_slot: "2025-06-03  1:00:00 PM",
          },
          {
            timestamp: 1748971800,
            time_slot: "2025-06-03  1:30:00 PM",
          },
          {
            timestamp: 1748973600,
            time_slot: "2025-06-03  2:00:00 PM",
          },
          {
            timestamp: 1748975400,
            time_slot: "2025-06-03  2:30:00 PM",
          },
          {
            timestamp: 1748977200,
            time_slot: "2025-06-03  3:00:00 PM",
          },
          {
            timestamp: 1748979000,
            time_slot: "2025-06-03  3:30:00 PM",
          },
          {
            timestamp: 1748980800,
            time_slot: "2025-06-03  4:00:00 PM",
          },
          {
            timestamp: 1748982600,
            time_slot: "2025-06-03  4:30:00 PM",
          },
          {
            timestamp: 1748984400,
            time_slot: "2025-06-03  5:00:00 PM",
          },
          {
            timestamp: 1749038400,
            time_slot: "2025-06-04  8:00:00 AM",
          },
          {
            timestamp: 1749040200,
            time_slot: "2025-06-04  8:30:00 AM",
          },
          {
            timestamp: 1749042000,
            time_slot: "2025-06-04  9:00:00 AM",
          },
          {
            timestamp: 1749043800,
            time_slot: "2025-06-04  9:30:00 AM",
          },
          {
            timestamp: 1749045600,
            time_slot: "2025-06-04 10:00:00 AM",
          },
          {
            timestamp: 1749047400,
            time_slot: "2025-06-04 10:30:00 AM",
          },
          {
            timestamp: 1749049200,
            time_slot: "2025-06-04 11:00:00 AM",
          },
          {
            timestamp: 1749051000,
            time_slot: "2025-06-04 11:30:00 AM",
          },
          {
            timestamp: 1749052800,
            time_slot: "2025-06-04 12:00:00 PM",
          },
          {
            timestamp: 1749054600,
            time_slot: "2025-06-04 12:30:00 PM",
          },
          {
            timestamp: 1749056400,
            time_slot: "2025-06-04  1:00:00 PM",
          },
          {
            timestamp: 1749058200,
            time_slot: "2025-06-04  1:30:00 PM",
          },
          {
            timestamp: 1749060000,
            time_slot: "2025-06-04  2:00:00 PM",
          },
          {
            timestamp: 1749061800,
            time_slot: "2025-06-04  2:30:00 PM",
          },
          {
            timestamp: 1749063600,
            time_slot: "2025-06-04  3:00:00 PM",
          },
          {
            timestamp: 1749065400,
            time_slot: "2025-06-04  3:30:00 PM",
          },
          {
            timestamp: 1749067200,
            time_slot: "2025-06-04  4:00:00 PM",
          },
          {
            timestamp: 1749124800,
            time_slot: "2025-06-05  8:00:00 AM",
          },
          {
            timestamp: 1749126600,
            time_slot: "2025-06-05  8:30:00 AM",
          },
          {
            timestamp: 1749128400,
            time_slot: "2025-06-05  9:00:00 AM",
          },
          {
            timestamp: 1749130200,
            time_slot: "2025-06-05  9:30:00 AM",
          },
          {
            timestamp: 1749132000,
            time_slot: "2025-06-05 10:00:00 AM",
          },
          {
            timestamp: 1749133800,
            time_slot: "2025-06-05 10:30:00 AM",
          },
          {
            timestamp: 1749135600,
            time_slot: "2025-06-05 11:00:00 AM",
          },
          {
            timestamp: 1749137400,
            time_slot: "2025-06-05 11:30:00 AM",
          },
          {
            timestamp: 1749139200,
            time_slot: "2025-06-05 12:00:00 PM",
          },
          {
            timestamp: 1749141000,
            time_slot: "2025-06-05 12:30:00 PM",
          },
          {
            timestamp: 1749142800,
            time_slot: "2025-06-05  1:00:00 PM",
          },
          {
            timestamp: 1749144600,
            time_slot: "2025-06-05  1:30:00 PM",
          },
          {
            timestamp: 1749146400,
            time_slot: "2025-06-05  2:00:00 PM",
          },
          {
            timestamp: 1749148200,
            time_slot: "2025-06-05  2:30:00 PM",
          },
          {
            timestamp: 1749150000,
            time_slot: "2025-06-05  3:00:00 PM",
          },
          {
            timestamp: 1749151800,
            time_slot: "2025-06-05  3:30:00 PM",
          },
          {
            timestamp: 1749153600,
            time_slot: "2025-06-05  4:00:00 PM",
          },
          {
            timestamp: 1749155400,
            time_slot: "2025-06-05  4:30:00 PM",
          },
          {
            timestamp: 1749157200,
            time_slot: "2025-06-05  5:00:00 PM",
          },
          {
            timestamp: 1749294000,
            time_slot: "2025-06-07  7:00:00 AM",
          },
          {
            timestamp: 1749295800,
            time_slot: "2025-06-07  7:30:00 AM",
          },
          {
            timestamp: 1749297600,
            time_slot: "2025-06-07  8:00:00 AM",
          },
          {
            timestamp: 1749299400,
            time_slot: "2025-06-07  8:30:00 AM",
          },
          {
            timestamp: 1749301200,
            time_slot: "2025-06-07  9:00:00 AM",
          },
          {
            timestamp: 1749303000,
            time_slot: "2025-06-07  9:30:00 AM",
          },
          {
            timestamp: 1749304800,
            time_slot: "2025-06-07 10:00:00 AM",
          },
          {
            timestamp: 1749306600,
            time_slot: "2025-06-07 10:30:00 AM",
          },
          {
            timestamp: 1749308400,
            time_slot: "2025-06-07 11:00:00 AM",
          },
          {
            timestamp: 1749310200,
            time_slot: "2025-06-07 11:30:00 AM",
          },
          {
            timestamp: 1749313800,
            time_slot: "2025-06-07 12:30:00 PM",
          },
          {
            timestamp: 1749315600,
            time_slot: "2025-06-07  1:00:00 PM",
          },
          {
            timestamp: 1749317400,
            time_slot: "2025-06-07  1:30:00 PM",
          },
          {
            timestamp: 1749319200,
            time_slot: "2025-06-07  2:00:00 PM",
          },
          {
            timestamp: 1749321000,
            time_slot: "2025-06-07  2:30:00 PM",
          },
          {
            timestamp: 1749322800,
            time_slot: "2025-06-07  3:00:00 PM",
          },
        ],
      },
      {
        live_video_tour: [
          {
            timestamp: 1746799200,
            time_slot: "2025-05-09 10:00:00 AM",
          },
          {
            timestamp: 1746801000,
            time_slot: "2025-05-09 10:30:00 AM",
          },
          {
            timestamp: 1746802800,
            time_slot: "2025-05-09 11:00:00 AM",
          },
          {
            timestamp: 1746804600,
            time_slot: "2025-05-09 11:30:00 AM",
          },
          {
            timestamp: 1746806400,
            time_slot: "2025-05-09 12:00:00 PM",
          },
          {
            timestamp: 1746808200,
            time_slot: "2025-05-09 12:30:00 PM",
          },
          {
            timestamp: 1746810000,
            time_slot: "2025-05-09  1:00:00 PM",
          },
          {
            timestamp: 1746811800,
            time_slot: "2025-05-09  1:30:00 PM",
          },
          {
            timestamp: 1746813600,
            time_slot: "2025-05-09  2:00:00 PM",
          },
          {
            timestamp: 1746815400,
            time_slot: "2025-05-09  2:30:00 PM",
          },
          {
            timestamp: 1746817200,
            time_slot: "2025-05-09  3:00:00 PM",
          },
          {
            timestamp: 1746819000,
            time_slot: "2025-05-09  3:30:00 PM",
          },
          {
            timestamp: 1746874800,
            time_slot: "2025-05-10  7:00:00 AM",
          },
          {
            timestamp: 1746876600,
            time_slot: "2025-05-10  7:30:00 AM",
          },
          {
            timestamp: 1746878400,
            time_slot: "2025-05-10  8:00:00 AM",
          },
          {
            timestamp: 1746880200,
            time_slot: "2025-05-10  8:30:00 AM",
          },
          {
            timestamp: 1746882000,
            time_slot: "2025-05-10  9:00:00 AM",
          },
          {
            timestamp: 1746883800,
            time_slot: "2025-05-10  9:30:00 AM",
          },
          {
            timestamp: 1746885600,
            time_slot: "2025-05-10 10:00:00 AM",
          },
          {
            timestamp: 1746887400,
            time_slot: "2025-05-10 10:30:00 AM",
          },
          {
            timestamp: 1746889200,
            time_slot: "2025-05-10 11:00:00 AM",
          },
          {
            timestamp: 1746891000,
            time_slot: "2025-05-10 11:30:00 AM",
          },
          {
            timestamp: 1746892800,
            time_slot: "2025-05-10 12:00:00 PM",
          },
          {
            timestamp: 1746894600,
            time_slot: "2025-05-10 12:30:00 PM",
          },
          {
            timestamp: 1746896400,
            time_slot: "2025-05-10  1:00:00 PM",
          },
          {
            timestamp: 1746898200,
            time_slot: "2025-05-10  1:30:00 PM",
          },
          {
            timestamp: 1746900000,
            time_slot: "2025-05-10  2:00:00 PM",
          },
          {
            timestamp: 1746901800,
            time_slot: "2025-05-10  2:30:00 PM",
          },
          {
            timestamp: 1746903600,
            time_slot: "2025-05-10  3:00:00 PM",
          },
          {
            timestamp: 1746905400,
            time_slot: "2025-05-10  3:30:00 PM",
          },
          {
            timestamp: 1746968400,
            time_slot: "2025-05-11  9:00:00 AM",
          },
          {
            timestamp: 1746970200,
            time_slot: "2025-05-11  9:30:00 AM",
          },
          {
            timestamp: 1746972000,
            time_slot: "2025-05-11 10:00:00 AM",
          },
          {
            timestamp: 1746973800,
            time_slot: "2025-05-11 10:30:00 AM",
          },
          {
            timestamp: 1746975600,
            time_slot: "2025-05-11 11:00:00 AM",
          },
          {
            timestamp: 1746977400,
            time_slot: "2025-05-11 11:30:00 AM",
          },
          {
            timestamp: 1746979200,
            time_slot: "2025-05-11 12:00:00 PM",
          },
          {
            timestamp: 1746981000,
            time_slot: "2025-05-11 12:30:00 PM",
          },
          {
            timestamp: 1746982800,
            time_slot: "2025-05-11  1:00:00 PM",
          },
          {
            timestamp: 1746984600,
            time_slot: "2025-05-11  1:30:00 PM",
          },
          {
            timestamp: 1746986400,
            time_slot: "2025-05-11  2:00:00 PM",
          },
          {
            timestamp: 1746988200,
            time_slot: "2025-05-11  2:30:00 PM",
          },
          {
            timestamp: 1746990000,
            time_slot: "2025-05-11  3:00:00 PM",
          },
          {
            timestamp: 1746991800,
            time_slot: "2025-05-11  3:30:00 PM",
          },
          {
            timestamp: 1746993600,
            time_slot: "2025-05-11  4:00:00 PM",
          },
          {
            timestamp: 1746995400,
            time_slot: "2025-05-11  4:30:00 PM",
          },
          {
            timestamp: 1747054800,
            time_slot: "2025-05-12  9:00:00 AM",
          },
          {
            timestamp: 1747056600,
            time_slot: "2025-05-12  9:30:00 AM",
          },
          {
            timestamp: 1747058400,
            time_slot: "2025-05-12 10:00:00 AM",
          },
          {
            timestamp: 1747060200,
            time_slot: "2025-05-12 10:30:00 AM",
          },
          {
            timestamp: 1747062000,
            time_slot: "2025-05-12 11:00:00 AM",
          },
          {
            timestamp: 1747063800,
            time_slot: "2025-05-12 11:30:00 AM",
          },
          {
            timestamp: 1747065600,
            time_slot: "2025-05-12 12:00:00 PM",
          },
          {
            timestamp: 1747067400,
            time_slot: "2025-05-12 12:30:00 PM",
          },
          {
            timestamp: 1747069200,
            time_slot: "2025-05-12  1:00:00 PM",
          },
          {
            timestamp: 1747071000,
            time_slot: "2025-05-12  1:30:00 PM",
          },
          {
            timestamp: 1747072800,
            time_slot: "2025-05-12  2:00:00 PM",
          },
          {
            timestamp: 1747074600,
            time_slot: "2025-05-12  2:30:00 PM",
          },
          {
            timestamp: 1747076400,
            time_slot: "2025-05-12  3:00:00 PM",
          },
          {
            timestamp: 1747078200,
            time_slot: "2025-05-12  3:30:00 PM",
          },
          {
            timestamp: 1747080000,
            time_slot: "2025-05-12  4:00:00 PM",
          },
          {
            timestamp: 1747081800,
            time_slot: "2025-05-12  4:30:00 PM",
          },
          {
            timestamp: 1747083600,
            time_slot: "2025-05-12  5:00:00 PM",
          },
          {
            timestamp: 1747085400,
            time_slot: "2025-05-12  5:30:00 PM",
          },
          {
            timestamp: 1747137600,
            time_slot: "2025-05-13  8:00:00 AM",
          },
          {
            timestamp: 1747139400,
            time_slot: "2025-05-13  8:30:00 AM",
          },
          {
            timestamp: 1747141200,
            time_slot: "2025-05-13  9:00:00 AM",
          },
          {
            timestamp: 1747143000,
            time_slot: "2025-05-13  9:30:00 AM",
          },
          {
            timestamp: 1747144800,
            time_slot: "2025-05-13 10:00:00 AM",
          },
          {
            timestamp: 1747146600,
            time_slot: "2025-05-13 10:30:00 AM",
          },
          {
            timestamp: 1747148400,
            time_slot: "2025-05-13 11:00:00 AM",
          },
          {
            timestamp: 1747150200,
            time_slot: "2025-05-13 11:30:00 AM",
          },
          {
            timestamp: 1747153800,
            time_slot: "2025-05-13 12:30:00 PM",
          },
          {
            timestamp: 1747155600,
            time_slot: "2025-05-13  1:00:00 PM",
          },
          {
            timestamp: 1747157400,
            time_slot: "2025-05-13  1:30:00 PM",
          },
          {
            timestamp: 1747159200,
            time_slot: "2025-05-13  2:00:00 PM",
          },
          {
            timestamp: 1747161000,
            time_slot: "2025-05-13  2:30:00 PM",
          },
          {
            timestamp: 1747162800,
            time_slot: "2025-05-13  3:00:00 PM",
          },
          {
            timestamp: 1747164600,
            time_slot: "2025-05-13  3:30:00 PM",
          },
          {
            timestamp: 1747166400,
            time_slot: "2025-05-13  4:00:00 PM",
          },
          {
            timestamp: 1747168200,
            time_slot: "2025-05-13  4:30:00 PM",
          },
          {
            timestamp: 1747170000,
            time_slot: "2025-05-13  5:00:00 PM",
          },
          {
            timestamp: 1747171800,
            time_slot: "2025-05-13  5:30:00 PM",
          },
          {
            timestamp: 1747220400,
            time_slot: "2025-05-14  7:00:00 AM",
          },
          {
            timestamp: 1747222200,
            time_slot: "2025-05-14  7:30:00 AM",
          },
          {
            timestamp: 1747224000,
            time_slot: "2025-05-14  8:00:00 AM",
          },
          {
            timestamp: 1747225800,
            time_slot: "2025-05-14  8:30:00 AM",
          },
          {
            timestamp: 1747227600,
            time_slot: "2025-05-14  9:00:00 AM",
          },
          {
            timestamp: 1747229400,
            time_slot: "2025-05-14  9:30:00 AM",
          },
          {
            timestamp: 1747231200,
            time_slot: "2025-05-14 10:00:00 AM",
          },
          {
            timestamp: 1747233000,
            time_slot: "2025-05-14 10:30:00 AM",
          },
          {
            timestamp: 1747234800,
            time_slot: "2025-05-14 11:00:00 AM",
          },
          {
            timestamp: 1747236600,
            time_slot: "2025-05-14 11:30:00 AM",
          },
          {
            timestamp: 1747238400,
            time_slot: "2025-05-14 12:00:00 PM",
          },
          {
            timestamp: 1747240200,
            time_slot: "2025-05-14 12:30:00 PM",
          },
          {
            timestamp: 1747242000,
            time_slot: "2025-05-14  1:00:00 PM",
          },
          {
            timestamp: 1747243800,
            time_slot: "2025-05-14  1:30:00 PM",
          },
          {
            timestamp: 1747245600,
            time_slot: "2025-05-14  2:00:00 PM",
          },
          {
            timestamp: 1747247400,
            time_slot: "2025-05-14  2:30:00 PM",
          },
          {
            timestamp: 1747249200,
            time_slot: "2025-05-14  3:00:00 PM",
          },
          {
            timestamp: 1747251000,
            time_slot: "2025-05-14  3:30:00 PM",
          },
          {
            timestamp: 1747252800,
            time_slot: "2025-05-14  4:00:00 PM",
          },
          {
            timestamp: 1747254600,
            time_slot: "2025-05-14  4:30:00 PM",
          },
          {
            timestamp: 1747310400,
            time_slot: "2025-05-15  8:00:00 AM",
          },
          {
            timestamp: 1747312200,
            time_slot: "2025-05-15  8:30:00 AM",
          },
          {
            timestamp: 1747314000,
            time_slot: "2025-05-15  9:00:00 AM",
          },
          {
            timestamp: 1747315800,
            time_slot: "2025-05-15  9:30:00 AM",
          },
          {
            timestamp: 1747317600,
            time_slot: "2025-05-15 10:00:00 AM",
          },
          {
            timestamp: 1747319400,
            time_slot: "2025-05-15 10:30:00 AM",
          },
          {
            timestamp: 1747321200,
            time_slot: "2025-05-15 11:00:00 AM",
          },
          {
            timestamp: 1747323000,
            time_slot: "2025-05-15 11:30:00 AM",
          },
          {
            timestamp: 1747326600,
            time_slot: "2025-05-15 12:30:00 PM",
          },
          {
            timestamp: 1747328400,
            time_slot: "2025-05-15  1:00:00 PM",
          },
          {
            timestamp: 1747330200,
            time_slot: "2025-05-15  1:30:00 PM",
          },
          {
            timestamp: 1747332000,
            time_slot: "2025-05-15  2:00:00 PM",
          },
          {
            timestamp: 1747333800,
            time_slot: "2025-05-15  2:30:00 PM",
          },
          {
            timestamp: 1747335600,
            time_slot: "2025-05-15  3:00:00 PM",
          },
          {
            timestamp: 1747337400,
            time_slot: "2025-05-15  3:30:00 PM",
          },
          {
            timestamp: 1747339200,
            time_slot: "2025-05-15  4:00:00 PM",
          },
          {
            timestamp: 1747341000,
            time_slot: "2025-05-15  4:30:00 PM",
          },
          {
            timestamp: 1747342800,
            time_slot: "2025-05-15  5:00:00 PM",
          },
          {
            timestamp: 1747344600,
            time_slot: "2025-05-15  5:30:00 PM",
          },
          {
            timestamp: 1747404000,
            time_slot: "2025-05-16 10:00:00 AM",
          },
          {
            timestamp: 1747405800,
            time_slot: "2025-05-16 10:30:00 AM",
          },
          {
            timestamp: 1747407600,
            time_slot: "2025-05-16 11:00:00 AM",
          },
          {
            timestamp: 1747409400,
            time_slot: "2025-05-16 11:30:00 AM",
          },
          {
            timestamp: 1747411200,
            time_slot: "2025-05-16 12:00:00 PM",
          },
          {
            timestamp: 1747413000,
            time_slot: "2025-05-16 12:30:00 PM",
          },
          {
            timestamp: 1747414800,
            time_slot: "2025-05-16  1:00:00 PM",
          },
          {
            timestamp: 1747416600,
            time_slot: "2025-05-16  1:30:00 PM",
          },
          {
            timestamp: 1747418400,
            time_slot: "2025-05-16  2:00:00 PM",
          },
          {
            timestamp: 1747420200,
            time_slot: "2025-05-16  2:30:00 PM",
          },
          {
            timestamp: 1747422000,
            time_slot: "2025-05-16  3:00:00 PM",
          },
          {
            timestamp: 1747423800,
            time_slot: "2025-05-16  3:30:00 PM",
          },
          {
            timestamp: 1747479600,
            time_slot: "2025-05-17  7:00:00 AM",
          },
          {
            timestamp: 1747481400,
            time_slot: "2025-05-17  7:30:00 AM",
          },
          {
            timestamp: 1747483200,
            time_slot: "2025-05-17  8:00:00 AM",
          },
          {
            timestamp: 1747485000,
            time_slot: "2025-05-17  8:30:00 AM",
          },
          {
            timestamp: 1747486800,
            time_slot: "2025-05-17  9:00:00 AM",
          },
          {
            timestamp: 1747488600,
            time_slot: "2025-05-17  9:30:00 AM",
          },
          {
            timestamp: 1747490400,
            time_slot: "2025-05-17 10:00:00 AM",
          },
          {
            timestamp: 1747492200,
            time_slot: "2025-05-17 10:30:00 AM",
          },
          {
            timestamp: 1747494000,
            time_slot: "2025-05-17 11:00:00 AM",
          },
          {
            timestamp: 1747495800,
            time_slot: "2025-05-17 11:30:00 AM",
          },
          {
            timestamp: 1747497600,
            time_slot: "2025-05-17 12:00:00 PM",
          },
          {
            timestamp: 1747499400,
            time_slot: "2025-05-17 12:30:00 PM",
          },
          {
            timestamp: 1747501200,
            time_slot: "2025-05-17  1:00:00 PM",
          },
          {
            timestamp: 1747503000,
            time_slot: "2025-05-17  1:30:00 PM",
          },
          {
            timestamp: 1747504800,
            time_slot: "2025-05-17  2:00:00 PM",
          },
          {
            timestamp: 1747506600,
            time_slot: "2025-05-17  2:30:00 PM",
          },
          {
            timestamp: 1747508400,
            time_slot: "2025-05-17  3:00:00 PM",
          },
          {
            timestamp: 1747510200,
            time_slot: "2025-05-17  3:30:00 PM",
          },
          {
            timestamp: 1747573200,
            time_slot: "2025-05-18  9:00:00 AM",
          },
          {
            timestamp: 1747575000,
            time_slot: "2025-05-18  9:30:00 AM",
          },
          {
            timestamp: 1747576800,
            time_slot: "2025-05-18 10:00:00 AM",
          },
          {
            timestamp: 1747578600,
            time_slot: "2025-05-18 10:30:00 AM",
          },
          {
            timestamp: 1747580400,
            time_slot: "2025-05-18 11:00:00 AM",
          },
          {
            timestamp: 1747582200,
            time_slot: "2025-05-18 11:30:00 AM",
          },
          {
            timestamp: 1747584000,
            time_slot: "2025-05-18 12:00:00 PM",
          },
          {
            timestamp: 1747585800,
            time_slot: "2025-05-18 12:30:00 PM",
          },
          {
            timestamp: 1747587600,
            time_slot: "2025-05-18  1:00:00 PM",
          },
          {
            timestamp: 1747589400,
            time_slot: "2025-05-18  1:30:00 PM",
          },
          {
            timestamp: 1747591200,
            time_slot: "2025-05-18  2:00:00 PM",
          },
          {
            timestamp: 1747593000,
            time_slot: "2025-05-18  2:30:00 PM",
          },
          {
            timestamp: 1747594800,
            time_slot: "2025-05-18  3:00:00 PM",
          },
          {
            timestamp: 1747596600,
            time_slot: "2025-05-18  3:30:00 PM",
          },
          {
            timestamp: 1747598400,
            time_slot: "2025-05-18  4:00:00 PM",
          },
          {
            timestamp: 1747600200,
            time_slot: "2025-05-18  4:30:00 PM",
          },
          {
            timestamp: 1747659600,
            time_slot: "2025-05-19  9:00:00 AM",
          },
          {
            timestamp: 1747661400,
            time_slot: "2025-05-19  9:30:00 AM",
          },
          {
            timestamp: 1747663200,
            time_slot: "2025-05-19 10:00:00 AM",
          },
          {
            timestamp: 1747665000,
            time_slot: "2025-05-19 10:30:00 AM",
          },
          {
            timestamp: 1747666800,
            time_slot: "2025-05-19 11:00:00 AM",
          },
          {
            timestamp: 1747668600,
            time_slot: "2025-05-19 11:30:00 AM",
          },
          {
            timestamp: 1747670400,
            time_slot: "2025-05-19 12:00:00 PM",
          },
          {
            timestamp: 1747672200,
            time_slot: "2025-05-19 12:30:00 PM",
          },
          {
            timestamp: 1747674000,
            time_slot: "2025-05-19  1:00:00 PM",
          },
          {
            timestamp: 1747675800,
            time_slot: "2025-05-19  1:30:00 PM",
          },
          {
            timestamp: 1747677600,
            time_slot: "2025-05-19  2:00:00 PM",
          },
          {
            timestamp: 1747679400,
            time_slot: "2025-05-19  2:30:00 PM",
          },
          {
            timestamp: 1747681200,
            time_slot: "2025-05-19  3:00:00 PM",
          },
          {
            timestamp: 1747683000,
            time_slot: "2025-05-19  3:30:00 PM",
          },
          {
            timestamp: 1747684800,
            time_slot: "2025-05-19  4:00:00 PM",
          },
          {
            timestamp: 1747686600,
            time_slot: "2025-05-19  4:30:00 PM",
          },
          {
            timestamp: 1747688400,
            time_slot: "2025-05-19  5:00:00 PM",
          },
          {
            timestamp: 1747690200,
            time_slot: "2025-05-19  5:30:00 PM",
          },
          {
            timestamp: 1747742400,
            time_slot: "2025-05-20  8:00:00 AM",
          },
          {
            timestamp: 1747744200,
            time_slot: "2025-05-20  8:30:00 AM",
          },
          {
            timestamp: 1747746000,
            time_slot: "2025-05-20  9:00:00 AM",
          },
          {
            timestamp: 1747747800,
            time_slot: "2025-05-20  9:30:00 AM",
          },
          {
            timestamp: 1747749600,
            time_slot: "2025-05-20 10:00:00 AM",
          },
          {
            timestamp: 1747751400,
            time_slot: "2025-05-20 10:30:00 AM",
          },
          {
            timestamp: 1747753200,
            time_slot: "2025-05-20 11:00:00 AM",
          },
          {
            timestamp: 1747755000,
            time_slot: "2025-05-20 11:30:00 AM",
          },
          {
            timestamp: 1747758600,
            time_slot: "2025-05-20 12:30:00 PM",
          },
          {
            timestamp: 1747760400,
            time_slot: "2025-05-20  1:00:00 PM",
          },
          {
            timestamp: 1747762200,
            time_slot: "2025-05-20  1:30:00 PM",
          },
          {
            timestamp: 1747764000,
            time_slot: "2025-05-20  2:00:00 PM",
          },
          {
            timestamp: 1747765800,
            time_slot: "2025-05-20  2:30:00 PM",
          },
          {
            timestamp: 1747767600,
            time_slot: "2025-05-20  3:00:00 PM",
          },
          {
            timestamp: 1747769400,
            time_slot: "2025-05-20  3:30:00 PM",
          },
          {
            timestamp: 1747771200,
            time_slot: "2025-05-20  4:00:00 PM",
          },
          {
            timestamp: 1747773000,
            time_slot: "2025-05-20  4:30:00 PM",
          },
          {
            timestamp: 1747774800,
            time_slot: "2025-05-20  5:00:00 PM",
          },
          {
            timestamp: 1747776600,
            time_slot: "2025-05-20  5:30:00 PM",
          },
          {
            timestamp: 1747825200,
            time_slot: "2025-05-21  7:00:00 AM",
          },
          {
            timestamp: 1747827000,
            time_slot: "2025-05-21  7:30:00 AM",
          },
          {
            timestamp: 1747828800,
            time_slot: "2025-05-21  8:00:00 AM",
          },
          {
            timestamp: 1747830600,
            time_slot: "2025-05-21  8:30:00 AM",
          },
          {
            timestamp: 1747832400,
            time_slot: "2025-05-21  9:00:00 AM",
          },
          {
            timestamp: 1747834200,
            time_slot: "2025-05-21  9:30:00 AM",
          },
          {
            timestamp: 1747836000,
            time_slot: "2025-05-21 10:00:00 AM",
          },
          {
            timestamp: 1747837800,
            time_slot: "2025-05-21 10:30:00 AM",
          },
          {
            timestamp: 1747839600,
            time_slot: "2025-05-21 11:00:00 AM",
          },
          {
            timestamp: 1747841400,
            time_slot: "2025-05-21 11:30:00 AM",
          },
          {
            timestamp: 1747843200,
            time_slot: "2025-05-21 12:00:00 PM",
          },
          {
            timestamp: 1747845000,
            time_slot: "2025-05-21 12:30:00 PM",
          },
          {
            timestamp: 1747846800,
            time_slot: "2025-05-21  1:00:00 PM",
          },
          {
            timestamp: 1747848600,
            time_slot: "2025-05-21  1:30:00 PM",
          },
          {
            timestamp: 1747850400,
            time_slot: "2025-05-21  2:00:00 PM",
          },
          {
            timestamp: 1747852200,
            time_slot: "2025-05-21  2:30:00 PM",
          },
          {
            timestamp: 1747854000,
            time_slot: "2025-05-21  3:00:00 PM",
          },
          {
            timestamp: 1747855800,
            time_slot: "2025-05-21  3:30:00 PM",
          },
          {
            timestamp: 1747857600,
            time_slot: "2025-05-21  4:00:00 PM",
          },
          {
            timestamp: 1747859400,
            time_slot: "2025-05-21  4:30:00 PM",
          },
          {
            timestamp: 1747915200,
            time_slot: "2025-05-22  8:00:00 AM",
          },
          {
            timestamp: 1747917000,
            time_slot: "2025-05-22  8:30:00 AM",
          },
          {
            timestamp: 1747918800,
            time_slot: "2025-05-22  9:00:00 AM",
          },
          {
            timestamp: 1747920600,
            time_slot: "2025-05-22  9:30:00 AM",
          },
          {
            timestamp: 1747922400,
            time_slot: "2025-05-22 10:00:00 AM",
          },
          {
            timestamp: 1747924200,
            time_slot: "2025-05-22 10:30:00 AM",
          },
          {
            timestamp: 1747926000,
            time_slot: "2025-05-22 11:00:00 AM",
          },
          {
            timestamp: 1747927800,
            time_slot: "2025-05-22 11:30:00 AM",
          },
          {
            timestamp: 1747931400,
            time_slot: "2025-05-22 12:30:00 PM",
          },
          {
            timestamp: 1747933200,
            time_slot: "2025-05-22  1:00:00 PM",
          },
          {
            timestamp: 1747935000,
            time_slot: "2025-05-22  1:30:00 PM",
          },
          {
            timestamp: 1747936800,
            time_slot: "2025-05-22  2:00:00 PM",
          },
          {
            timestamp: 1747938600,
            time_slot: "2025-05-22  2:30:00 PM",
          },
          {
            timestamp: 1747940400,
            time_slot: "2025-05-22  3:00:00 PM",
          },
          {
            timestamp: 1747942200,
            time_slot: "2025-05-22  3:30:00 PM",
          },
          {
            timestamp: 1747944000,
            time_slot: "2025-05-22  4:00:00 PM",
          },
          {
            timestamp: 1747945800,
            time_slot: "2025-05-22  4:30:00 PM",
          },
          {
            timestamp: 1747947600,
            time_slot: "2025-05-22  5:00:00 PM",
          },
          {
            timestamp: 1747949400,
            time_slot: "2025-05-22  5:30:00 PM",
          },
          {
            timestamp: 1748008800,
            time_slot: "2025-05-23 10:00:00 AM",
          },
          {
            timestamp: 1748010600,
            time_slot: "2025-05-23 10:30:00 AM",
          },
          {
            timestamp: 1748012400,
            time_slot: "2025-05-23 11:00:00 AM",
          },
          {
            timestamp: 1748014200,
            time_slot: "2025-05-23 11:30:00 AM",
          },
          {
            timestamp: 1748016000,
            time_slot: "2025-05-23 12:00:00 PM",
          },
          {
            timestamp: 1748017800,
            time_slot: "2025-05-23 12:30:00 PM",
          },
          {
            timestamp: 1748019600,
            time_slot: "2025-05-23  1:00:00 PM",
          },
          {
            timestamp: 1748021400,
            time_slot: "2025-05-23  1:30:00 PM",
          },
          {
            timestamp: 1748023200,
            time_slot: "2025-05-23  2:00:00 PM",
          },
          {
            timestamp: 1748025000,
            time_slot: "2025-05-23  2:30:00 PM",
          },
          {
            timestamp: 1748026800,
            time_slot: "2025-05-23  3:00:00 PM",
          },
          {
            timestamp: 1748028600,
            time_slot: "2025-05-23  3:30:00 PM",
          },
          {
            timestamp: 1748084400,
            time_slot: "2025-05-24  7:00:00 AM",
          },
          {
            timestamp: 1748086200,
            time_slot: "2025-05-24  7:30:00 AM",
          },
          {
            timestamp: 1748088000,
            time_slot: "2025-05-24  8:00:00 AM",
          },
          {
            timestamp: 1748089800,
            time_slot: "2025-05-24  8:30:00 AM",
          },
          {
            timestamp: 1748091600,
            time_slot: "2025-05-24  9:00:00 AM",
          },
          {
            timestamp: 1748093400,
            time_slot: "2025-05-24  9:30:00 AM",
          },
          {
            timestamp: 1748095200,
            time_slot: "2025-05-24 10:00:00 AM",
          },
          {
            timestamp: 1748097000,
            time_slot: "2025-05-24 10:30:00 AM",
          },
          {
            timestamp: 1748098800,
            time_slot: "2025-05-24 11:00:00 AM",
          },
          {
            timestamp: 1748100600,
            time_slot: "2025-05-24 11:30:00 AM",
          },
          {
            timestamp: 1748102400,
            time_slot: "2025-05-24 12:00:00 PM",
          },
          {
            timestamp: 1748104200,
            time_slot: "2025-05-24 12:30:00 PM",
          },
          {
            timestamp: 1748106000,
            time_slot: "2025-05-24  1:00:00 PM",
          },
          {
            timestamp: 1748107800,
            time_slot: "2025-05-24  1:30:00 PM",
          },
          {
            timestamp: 1748109600,
            time_slot: "2025-05-24  2:00:00 PM",
          },
          {
            timestamp: 1748111400,
            time_slot: "2025-05-24  2:30:00 PM",
          },
          {
            timestamp: 1748113200,
            time_slot: "2025-05-24  3:00:00 PM",
          },
          {
            timestamp: 1748115000,
            time_slot: "2025-05-24  3:30:00 PM",
          },
          {
            timestamp: 1748178000,
            time_slot: "2025-05-25  9:00:00 AM",
          },
          {
            timestamp: 1748179800,
            time_slot: "2025-05-25  9:30:00 AM",
          },
          {
            timestamp: 1748181600,
            time_slot: "2025-05-25 10:00:00 AM",
          },
          {
            timestamp: 1748183400,
            time_slot: "2025-05-25 10:30:00 AM",
          },
          {
            timestamp: 1748185200,
            time_slot: "2025-05-25 11:00:00 AM",
          },
          {
            timestamp: 1748187000,
            time_slot: "2025-05-25 11:30:00 AM",
          },
          {
            timestamp: 1748188800,
            time_slot: "2025-05-25 12:00:00 PM",
          },
          {
            timestamp: 1748190600,
            time_slot: "2025-05-25 12:30:00 PM",
          },
          {
            timestamp: 1748192400,
            time_slot: "2025-05-25  1:00:00 PM",
          },
          {
            timestamp: 1748194200,
            time_slot: "2025-05-25  1:30:00 PM",
          },
          {
            timestamp: 1748196000,
            time_slot: "2025-05-25  2:00:00 PM",
          },
          {
            timestamp: 1748197800,
            time_slot: "2025-05-25  2:30:00 PM",
          },
          {
            timestamp: 1748199600,
            time_slot: "2025-05-25  3:00:00 PM",
          },
          {
            timestamp: 1748201400,
            time_slot: "2025-05-25  3:30:00 PM",
          },
          {
            timestamp: 1748203200,
            time_slot: "2025-05-25  4:00:00 PM",
          },
          {
            timestamp: 1748205000,
            time_slot: "2025-05-25  4:30:00 PM",
          },
          {
            timestamp: 1748264400,
            time_slot: "2025-05-26  9:00:00 AM",
          },
          {
            timestamp: 1748266200,
            time_slot: "2025-05-26  9:30:00 AM",
          },
          {
            timestamp: 1748268000,
            time_slot: "2025-05-26 10:00:00 AM",
          },
          {
            timestamp: 1748269800,
            time_slot: "2025-05-26 10:30:00 AM",
          },
          {
            timestamp: 1748271600,
            time_slot: "2025-05-26 11:00:00 AM",
          },
          {
            timestamp: 1748273400,
            time_slot: "2025-05-26 11:30:00 AM",
          },
          {
            timestamp: 1748275200,
            time_slot: "2025-05-26 12:00:00 PM",
          },
          {
            timestamp: 1748277000,
            time_slot: "2025-05-26 12:30:00 PM",
          },
          {
            timestamp: 1748278800,
            time_slot: "2025-05-26  1:00:00 PM",
          },
          {
            timestamp: 1748280600,
            time_slot: "2025-05-26  1:30:00 PM",
          },
          {
            timestamp: 1748282400,
            time_slot: "2025-05-26  2:00:00 PM",
          },
          {
            timestamp: 1748284200,
            time_slot: "2025-05-26  2:30:00 PM",
          },
          {
            timestamp: 1748286000,
            time_slot: "2025-05-26  3:00:00 PM",
          },
          {
            timestamp: 1748287800,
            time_slot: "2025-05-26  3:30:00 PM",
          },
          {
            timestamp: 1748289600,
            time_slot: "2025-05-26  4:00:00 PM",
          },
          {
            timestamp: 1748291400,
            time_slot: "2025-05-26  4:30:00 PM",
          },
          {
            timestamp: 1748293200,
            time_slot: "2025-05-26  5:00:00 PM",
          },
          {
            timestamp: 1748295000,
            time_slot: "2025-05-26  5:30:00 PM",
          },
          {
            timestamp: 1748347200,
            time_slot: "2025-05-27  8:00:00 AM",
          },
          {
            timestamp: 1748349000,
            time_slot: "2025-05-27  8:30:00 AM",
          },
          {
            timestamp: 1748350800,
            time_slot: "2025-05-27  9:00:00 AM",
          },
          {
            timestamp: 1748352600,
            time_slot: "2025-05-27  9:30:00 AM",
          },
          {
            timestamp: 1748354400,
            time_slot: "2025-05-27 10:00:00 AM",
          },
          {
            timestamp: 1748356200,
            time_slot: "2025-05-27 10:30:00 AM",
          },
          {
            timestamp: 1748358000,
            time_slot: "2025-05-27 11:00:00 AM",
          },
          {
            timestamp: 1748359800,
            time_slot: "2025-05-27 11:30:00 AM",
          },
          {
            timestamp: 1748363400,
            time_slot: "2025-05-27 12:30:00 PM",
          },
          {
            timestamp: 1748365200,
            time_slot: "2025-05-27  1:00:00 PM",
          },
          {
            timestamp: 1748367000,
            time_slot: "2025-05-27  1:30:00 PM",
          },
          {
            timestamp: 1748368800,
            time_slot: "2025-05-27  2:00:00 PM",
          },
          {
            timestamp: 1748370600,
            time_slot: "2025-05-27  2:30:00 PM",
          },
          {
            timestamp: 1748372400,
            time_slot: "2025-05-27  3:00:00 PM",
          },
          {
            timestamp: 1748374200,
            time_slot: "2025-05-27  3:30:00 PM",
          },
          {
            timestamp: 1748376000,
            time_slot: "2025-05-27  4:00:00 PM",
          },
          {
            timestamp: 1748377800,
            time_slot: "2025-05-27  4:30:00 PM",
          },
          {
            timestamp: 1748379600,
            time_slot: "2025-05-27  5:00:00 PM",
          },
          {
            timestamp: 1748381400,
            time_slot: "2025-05-27  5:30:00 PM",
          },
          {
            timestamp: 1748430000,
            time_slot: "2025-05-28  7:00:00 AM",
          },
          {
            timestamp: 1748431800,
            time_slot: "2025-05-28  7:30:00 AM",
          },
          {
            timestamp: 1748433600,
            time_slot: "2025-05-28  8:00:00 AM",
          },
          {
            timestamp: 1748435400,
            time_slot: "2025-05-28  8:30:00 AM",
          },
          {
            timestamp: 1748437200,
            time_slot: "2025-05-28  9:00:00 AM",
          },
          {
            timestamp: 1748439000,
            time_slot: "2025-05-28  9:30:00 AM",
          },
          {
            timestamp: 1748440800,
            time_slot: "2025-05-28 10:00:00 AM",
          },
          {
            timestamp: 1748442600,
            time_slot: "2025-05-28 10:30:00 AM",
          },
          {
            timestamp: 1748444400,
            time_slot: "2025-05-28 11:00:00 AM",
          },
          {
            timestamp: 1748446200,
            time_slot: "2025-05-28 11:30:00 AM",
          },
          {
            timestamp: 1748448000,
            time_slot: "2025-05-28 12:00:00 PM",
          },
          {
            timestamp: 1748449800,
            time_slot: "2025-05-28 12:30:00 PM",
          },
          {
            timestamp: 1748451600,
            time_slot: "2025-05-28  1:00:00 PM",
          },
          {
            timestamp: 1748453400,
            time_slot: "2025-05-28  1:30:00 PM",
          },
          {
            timestamp: 1748455200,
            time_slot: "2025-05-28  2:00:00 PM",
          },
          {
            timestamp: 1748457000,
            time_slot: "2025-05-28  2:30:00 PM",
          },
          {
            timestamp: 1748458800,
            time_slot: "2025-05-28  3:00:00 PM",
          },
          {
            timestamp: 1748460600,
            time_slot: "2025-05-28  3:30:00 PM",
          },
          {
            timestamp: 1748462400,
            time_slot: "2025-05-28  4:00:00 PM",
          },
          {
            timestamp: 1748464200,
            time_slot: "2025-05-28  4:30:00 PM",
          },
          {
            timestamp: 1748520000,
            time_slot: "2025-05-29  8:00:00 AM",
          },
          {
            timestamp: 1748521800,
            time_slot: "2025-05-29  8:30:00 AM",
          },
          {
            timestamp: 1748523600,
            time_slot: "2025-05-29  9:00:00 AM",
          },
          {
            timestamp: 1748525400,
            time_slot: "2025-05-29  9:30:00 AM",
          },
          {
            timestamp: 1748527200,
            time_slot: "2025-05-29 10:00:00 AM",
          },
          {
            timestamp: 1748529000,
            time_slot: "2025-05-29 10:30:00 AM",
          },
          {
            timestamp: 1748530800,
            time_slot: "2025-05-29 11:00:00 AM",
          },
          {
            timestamp: 1748532600,
            time_slot: "2025-05-29 11:30:00 AM",
          },
          {
            timestamp: 1748536200,
            time_slot: "2025-05-29 12:30:00 PM",
          },
          {
            timestamp: 1748538000,
            time_slot: "2025-05-29  1:00:00 PM",
          },
          {
            timestamp: 1748539800,
            time_slot: "2025-05-29  1:30:00 PM",
          },
          {
            timestamp: 1748541600,
            time_slot: "2025-05-29  2:00:00 PM",
          },
          {
            timestamp: 1748543400,
            time_slot: "2025-05-29  2:30:00 PM",
          },
          {
            timestamp: 1748545200,
            time_slot: "2025-05-29  3:00:00 PM",
          },
          {
            timestamp: 1748547000,
            time_slot: "2025-05-29  3:30:00 PM",
          },
          {
            timestamp: 1748548800,
            time_slot: "2025-05-29  4:00:00 PM",
          },
          {
            timestamp: 1748550600,
            time_slot: "2025-05-29  4:30:00 PM",
          },
          {
            timestamp: 1748552400,
            time_slot: "2025-05-29  5:00:00 PM",
          },
          {
            timestamp: 1748554200,
            time_slot: "2025-05-29  5:30:00 PM",
          },
          {
            timestamp: 1748613600,
            time_slot: "2025-05-30 10:00:00 AM",
          },
          {
            timestamp: 1748615400,
            time_slot: "2025-05-30 10:30:00 AM",
          },
          {
            timestamp: 1748617200,
            time_slot: "2025-05-30 11:00:00 AM",
          },
          {
            timestamp: 1748619000,
            time_slot: "2025-05-30 11:30:00 AM",
          },
          {
            timestamp: 1748620800,
            time_slot: "2025-05-30 12:00:00 PM",
          },
          {
            timestamp: 1748622600,
            time_slot: "2025-05-30 12:30:00 PM",
          },
          {
            timestamp: 1748624400,
            time_slot: "2025-05-30  1:00:00 PM",
          },
          {
            timestamp: 1748626200,
            time_slot: "2025-05-30  1:30:00 PM",
          },
          {
            timestamp: 1748628000,
            time_slot: "2025-05-30  2:00:00 PM",
          },
          {
            timestamp: 1748629800,
            time_slot: "2025-05-30  2:30:00 PM",
          },
          {
            timestamp: 1748631600,
            time_slot: "2025-05-30  3:00:00 PM",
          },
          {
            timestamp: 1748633400,
            time_slot: "2025-05-30  3:30:00 PM",
          },
          {
            timestamp: 1748689200,
            time_slot: "2025-05-31  7:00:00 AM",
          },
          {
            timestamp: 1748691000,
            time_slot: "2025-05-31  7:30:00 AM",
          },
          {
            timestamp: 1748692800,
            time_slot: "2025-05-31  8:00:00 AM",
          },
          {
            timestamp: 1748694600,
            time_slot: "2025-05-31  8:30:00 AM",
          },
          {
            timestamp: 1748696400,
            time_slot: "2025-05-31  9:00:00 AM",
          },
          {
            timestamp: 1748698200,
            time_slot: "2025-05-31  9:30:00 AM",
          },
          {
            timestamp: 1748700000,
            time_slot: "2025-05-31 10:00:00 AM",
          },
          {
            timestamp: 1748701800,
            time_slot: "2025-05-31 10:30:00 AM",
          },
          {
            timestamp: 1748703600,
            time_slot: "2025-05-31 11:00:00 AM",
          },
          {
            timestamp: 1748705400,
            time_slot: "2025-05-31 11:30:00 AM",
          },
          {
            timestamp: 1748707200,
            time_slot: "2025-05-31 12:00:00 PM",
          },
          {
            timestamp: 1748709000,
            time_slot: "2025-05-31 12:30:00 PM",
          },
          {
            timestamp: 1748710800,
            time_slot: "2025-05-31  1:00:00 PM",
          },
          {
            timestamp: 1748712600,
            time_slot: "2025-05-31  1:30:00 PM",
          },
          {
            timestamp: 1748714400,
            time_slot: "2025-05-31  2:00:00 PM",
          },
          {
            timestamp: 1748716200,
            time_slot: "2025-05-31  2:30:00 PM",
          },
          {
            timestamp: 1748718000,
            time_slot: "2025-05-31  3:00:00 PM",
          },
          {
            timestamp: 1748719800,
            time_slot: "2025-05-31  3:30:00 PM",
          },
        ],
      },
      {
        self_guided_tour: [
          {
            timestamp: 1746799200,
            time_slot: "2025-05-09 10:00:00 AM",
          },
          {
            timestamp: 1746801000,
            time_slot: "2025-05-09 10:30:00 AM",
          },
          {
            timestamp: 1746802800,
            time_slot: "2025-05-09 11:00:00 AM",
          },
          {
            timestamp: 1746804600,
            time_slot: "2025-05-09 11:30:00 AM",
          },
          {
            timestamp: 1746808200,
            time_slot: "2025-05-09 12:30:00 PM",
          },
          {
            timestamp: 1746810000,
            time_slot: "2025-05-09  1:00:00 PM",
          },
          {
            timestamp: 1746811800,
            time_slot: "2025-05-09  1:30:00 PM",
          },
          {
            timestamp: 1746813600,
            time_slot: "2025-05-09  2:00:00 PM",
          },
          {
            timestamp: 1746874800,
            time_slot: "2025-05-10  7:00:00 AM",
          },
          {
            timestamp: 1746876600,
            time_slot: "2025-05-10  7:30:00 AM",
          },
          {
            timestamp: 1746878400,
            time_slot: "2025-05-10  8:00:00 AM",
          },
          {
            timestamp: 1746880200,
            time_slot: "2025-05-10  8:30:00 AM",
          },
          {
            timestamp: 1746882000,
            time_slot: "2025-05-10  9:00:00 AM",
          },
          {
            timestamp: 1746883800,
            time_slot: "2025-05-10  9:30:00 AM",
          },
          {
            timestamp: 1746885600,
            time_slot: "2025-05-10 10:00:00 AM",
          },
          {
            timestamp: 1746887400,
            time_slot: "2025-05-10 10:30:00 AM",
          },
          {
            timestamp: 1746889200,
            time_slot: "2025-05-10 11:00:00 AM",
          },
          {
            timestamp: 1746891000,
            time_slot: "2025-05-10 11:30:00 AM",
          },
          {
            timestamp: 1746894600,
            time_slot: "2025-05-10 12:30:00 PM",
          },
          {
            timestamp: 1746896400,
            time_slot: "2025-05-10  1:00:00 PM",
          },
          {
            timestamp: 1746898200,
            time_slot: "2025-05-10  1:30:00 PM",
          },
          {
            timestamp: 1746900000,
            time_slot: "2025-05-10  2:00:00 PM",
          },
          {
            timestamp: 1746968400,
            time_slot: "2025-05-11  9:00:00 AM",
          },
          {
            timestamp: 1746970200,
            time_slot: "2025-05-11  9:30:00 AM",
          },
          {
            timestamp: 1746972000,
            time_slot: "2025-05-11 10:00:00 AM",
          },
          {
            timestamp: 1746973800,
            time_slot: "2025-05-11 10:30:00 AM",
          },
          {
            timestamp: 1746975600,
            time_slot: "2025-05-11 11:00:00 AM",
          },
          {
            timestamp: 1746977400,
            time_slot: "2025-05-11 11:30:00 AM",
          },
          {
            timestamp: 1746979200,
            time_slot: "2025-05-11 12:00:00 PM",
          },
          {
            timestamp: 1746981000,
            time_slot: "2025-05-11 12:30:00 PM",
          },
          {
            timestamp: 1746982800,
            time_slot: "2025-05-11  1:00:00 PM",
          },
          {
            timestamp: 1746984600,
            time_slot: "2025-05-11  1:30:00 PM",
          },
          {
            timestamp: 1746986400,
            time_slot: "2025-05-11  2:00:00 PM",
          },
          {
            timestamp: 1746988200,
            time_slot: "2025-05-11  2:30:00 PM",
          },
          {
            timestamp: 1746990000,
            time_slot: "2025-05-11  3:00:00 PM",
          },
          {
            timestamp: 1747054800,
            time_slot: "2025-05-12  9:00:00 AM",
          },
          {
            timestamp: 1747056600,
            time_slot: "2025-05-12  9:30:00 AM",
          },
          {
            timestamp: 1747058400,
            time_slot: "2025-05-12 10:00:00 AM",
          },
          {
            timestamp: 1747060200,
            time_slot: "2025-05-12 10:30:00 AM",
          },
          {
            timestamp: 1747062000,
            time_slot: "2025-05-12 11:00:00 AM",
          },
          {
            timestamp: 1747063800,
            time_slot: "2025-05-12 11:30:00 AM",
          },
          {
            timestamp: 1747065600,
            time_slot: "2025-05-12 12:00:00 PM",
          },
          {
            timestamp: 1747067400,
            time_slot: "2025-05-12 12:30:00 PM",
          },
          {
            timestamp: 1747072800,
            time_slot: "2025-05-12  2:00:00 PM",
          },
          {
            timestamp: 1747074600,
            time_slot: "2025-05-12  2:30:00 PM",
          },
          {
            timestamp: 1747076400,
            time_slot: "2025-05-12  3:00:00 PM",
          },
          {
            timestamp: 1747137600,
            time_slot: "2025-05-13  8:00:00 AM",
          },
          {
            timestamp: 1747139400,
            time_slot: "2025-05-13  8:30:00 AM",
          },
          {
            timestamp: 1747141200,
            time_slot: "2025-05-13  9:00:00 AM",
          },
          {
            timestamp: 1747143000,
            time_slot: "2025-05-13  9:30:00 AM",
          },
          {
            timestamp: 1747144800,
            time_slot: "2025-05-13 10:00:00 AM",
          },
          {
            timestamp: 1747146600,
            time_slot: "2025-05-13 10:30:00 AM",
          },
          {
            timestamp: 1747148400,
            time_slot: "2025-05-13 11:00:00 AM",
          },
          {
            timestamp: 1747150200,
            time_slot: "2025-05-13 11:30:00 AM",
          },
          {
            timestamp: 1747153800,
            time_slot: "2025-05-13 12:30:00 PM",
          },
          {
            timestamp: 1747155600,
            time_slot: "2025-05-13  1:00:00 PM",
          },
          {
            timestamp: 1747157400,
            time_slot: "2025-05-13  1:30:00 PM",
          },
          {
            timestamp: 1747159200,
            time_slot: "2025-05-13  2:00:00 PM",
          },
          {
            timestamp: 1747161000,
            time_slot: "2025-05-13  2:30:00 PM",
          },
          {
            timestamp: 1747162800,
            time_slot: "2025-05-13  3:00:00 PM",
          },
          {
            timestamp: 1747164600,
            time_slot: "2025-05-13  3:30:00 PM",
          },
          {
            timestamp: 1747166400,
            time_slot: "2025-05-13  4:00:00 PM",
          },
          {
            timestamp: 1747220400,
            time_slot: "2025-05-14  7:00:00 AM",
          },
          {
            timestamp: 1747222200,
            time_slot: "2025-05-14  7:30:00 AM",
          },
          {
            timestamp: 1747224000,
            time_slot: "2025-05-14  8:00:00 AM",
          },
          {
            timestamp: 1747225800,
            time_slot: "2025-05-14  8:30:00 AM",
          },
          {
            timestamp: 1747227600,
            time_slot: "2025-05-14  9:00:00 AM",
          },
          {
            timestamp: 1747229400,
            time_slot: "2025-05-14  9:30:00 AM",
          },
          {
            timestamp: 1747231200,
            time_slot: "2025-05-14 10:00:00 AM",
          },
          {
            timestamp: 1747233000,
            time_slot: "2025-05-14 10:30:00 AM",
          },
          {
            timestamp: 1747234800,
            time_slot: "2025-05-14 11:00:00 AM",
          },
          {
            timestamp: 1747236600,
            time_slot: "2025-05-14 11:30:00 AM",
          },
          {
            timestamp: 1747240200,
            time_slot: "2025-05-14 12:30:00 PM",
          },
          {
            timestamp: 1747242000,
            time_slot: "2025-05-14  1:00:00 PM",
          },
          {
            timestamp: 1747243800,
            time_slot: "2025-05-14  1:30:00 PM",
          },
          {
            timestamp: 1747245600,
            time_slot: "2025-05-14  2:00:00 PM",
          },
          {
            timestamp: 1747247400,
            time_slot: "2025-05-14  2:30:00 PM",
          },
          {
            timestamp: 1747249200,
            time_slot: "2025-05-14  3:00:00 PM",
          },
          {
            timestamp: 1747310400,
            time_slot: "2025-05-15  8:00:00 AM",
          },
          {
            timestamp: 1747312200,
            time_slot: "2025-05-15  8:30:00 AM",
          },
          {
            timestamp: 1747314000,
            time_slot: "2025-05-15  9:00:00 AM",
          },
          {
            timestamp: 1747315800,
            time_slot: "2025-05-15  9:30:00 AM",
          },
          {
            timestamp: 1747317600,
            time_slot: "2025-05-15 10:00:00 AM",
          },
          {
            timestamp: 1747319400,
            time_slot: "2025-05-15 10:30:00 AM",
          },
          {
            timestamp: 1747321200,
            time_slot: "2025-05-15 11:00:00 AM",
          },
          {
            timestamp: 1747323000,
            time_slot: "2025-05-15 11:30:00 AM",
          },
          {
            timestamp: 1747326600,
            time_slot: "2025-05-15 12:30:00 PM",
          },
          {
            timestamp: 1747328400,
            time_slot: "2025-05-15  1:00:00 PM",
          },
          {
            timestamp: 1747330200,
            time_slot: "2025-05-15  1:30:00 PM",
          },
          {
            timestamp: 1747332000,
            time_slot: "2025-05-15  2:00:00 PM",
          },
          {
            timestamp: 1747333800,
            time_slot: "2025-05-15  2:30:00 PM",
          },
          {
            timestamp: 1747335600,
            time_slot: "2025-05-15  3:00:00 PM",
          },
          {
            timestamp: 1747337400,
            time_slot: "2025-05-15  3:30:00 PM",
          },
          {
            timestamp: 1747339200,
            time_slot: "2025-05-15  4:00:00 PM",
          },
          {
            timestamp: 1747404000,
            time_slot: "2025-05-16 10:00:00 AM",
          },
          {
            timestamp: 1747405800,
            time_slot: "2025-05-16 10:30:00 AM",
          },
          {
            timestamp: 1747407600,
            time_slot: "2025-05-16 11:00:00 AM",
          },
          {
            timestamp: 1747409400,
            time_slot: "2025-05-16 11:30:00 AM",
          },
          {
            timestamp: 1747413000,
            time_slot: "2025-05-16 12:30:00 PM",
          },
          {
            timestamp: 1747414800,
            time_slot: "2025-05-16  1:00:00 PM",
          },
          {
            timestamp: 1747416600,
            time_slot: "2025-05-16  1:30:00 PM",
          },
          {
            timestamp: 1747418400,
            time_slot: "2025-05-16  2:00:00 PM",
          },
          {
            timestamp: 1747479600,
            time_slot: "2025-05-17  7:00:00 AM",
          },
          {
            timestamp: 1747481400,
            time_slot: "2025-05-17  7:30:00 AM",
          },
          {
            timestamp: 1747483200,
            time_slot: "2025-05-17  8:00:00 AM",
          },
          {
            timestamp: 1747485000,
            time_slot: "2025-05-17  8:30:00 AM",
          },
          {
            timestamp: 1747486800,
            time_slot: "2025-05-17  9:00:00 AM",
          },
          {
            timestamp: 1747488600,
            time_slot: "2025-05-17  9:30:00 AM",
          },
          {
            timestamp: 1747490400,
            time_slot: "2025-05-17 10:00:00 AM",
          },
          {
            timestamp: 1747492200,
            time_slot: "2025-05-17 10:30:00 AM",
          },
          {
            timestamp: 1747494000,
            time_slot: "2025-05-17 11:00:00 AM",
          },
          {
            timestamp: 1747495800,
            time_slot: "2025-05-17 11:30:00 AM",
          },
          {
            timestamp: 1747499400,
            time_slot: "2025-05-17 12:30:00 PM",
          },
          {
            timestamp: 1747501200,
            time_slot: "2025-05-17  1:00:00 PM",
          },
          {
            timestamp: 1747503000,
            time_slot: "2025-05-17  1:30:00 PM",
          },
          {
            timestamp: 1747504800,
            time_slot: "2025-05-17  2:00:00 PM",
          },
          {
            timestamp: 1747573200,
            time_slot: "2025-05-18  9:00:00 AM",
          },
          {
            timestamp: 1747575000,
            time_slot: "2025-05-18  9:30:00 AM",
          },
          {
            timestamp: 1747576800,
            time_slot: "2025-05-18 10:00:00 AM",
          },
          {
            timestamp: 1747578600,
            time_slot: "2025-05-18 10:30:00 AM",
          },
          {
            timestamp: 1747580400,
            time_slot: "2025-05-18 11:00:00 AM",
          },
          {
            timestamp: 1747582200,
            time_slot: "2025-05-18 11:30:00 AM",
          },
          {
            timestamp: 1747584000,
            time_slot: "2025-05-18 12:00:00 PM",
          },
          {
            timestamp: 1747585800,
            time_slot: "2025-05-18 12:30:00 PM",
          },
          {
            timestamp: 1747587600,
            time_slot: "2025-05-18  1:00:00 PM",
          },
          {
            timestamp: 1747589400,
            time_slot: "2025-05-18  1:30:00 PM",
          },
          {
            timestamp: 1747591200,
            time_slot: "2025-05-18  2:00:00 PM",
          },
          {
            timestamp: 1747593000,
            time_slot: "2025-05-18  2:30:00 PM",
          },
          {
            timestamp: 1747594800,
            time_slot: "2025-05-18  3:00:00 PM",
          },
          {
            timestamp: 1747659600,
            time_slot: "2025-05-19  9:00:00 AM",
          },
          {
            timestamp: 1747661400,
            time_slot: "2025-05-19  9:30:00 AM",
          },
          {
            timestamp: 1747663200,
            time_slot: "2025-05-19 10:00:00 AM",
          },
          {
            timestamp: 1747665000,
            time_slot: "2025-05-19 10:30:00 AM",
          },
          {
            timestamp: 1747666800,
            time_slot: "2025-05-19 11:00:00 AM",
          },
          {
            timestamp: 1747668600,
            time_slot: "2025-05-19 11:30:00 AM",
          },
          {
            timestamp: 1747670400,
            time_slot: "2025-05-19 12:00:00 PM",
          },
          {
            timestamp: 1747672200,
            time_slot: "2025-05-19 12:30:00 PM",
          },
          {
            timestamp: 1747677600,
            time_slot: "2025-05-19  2:00:00 PM",
          },
          {
            timestamp: 1747679400,
            time_slot: "2025-05-19  2:30:00 PM",
          },
          {
            timestamp: 1747681200,
            time_slot: "2025-05-19  3:00:00 PM",
          },
          {
            timestamp: 1747742400,
            time_slot: "2025-05-20  8:00:00 AM",
          },
          {
            timestamp: 1747744200,
            time_slot: "2025-05-20  8:30:00 AM",
          },
          {
            timestamp: 1747746000,
            time_slot: "2025-05-20  9:00:00 AM",
          },
          {
            timestamp: 1747747800,
            time_slot: "2025-05-20  9:30:00 AM",
          },
          {
            timestamp: 1747749600,
            time_slot: "2025-05-20 10:00:00 AM",
          },
          {
            timestamp: 1747751400,
            time_slot: "2025-05-20 10:30:00 AM",
          },
          {
            timestamp: 1747753200,
            time_slot: "2025-05-20 11:00:00 AM",
          },
          {
            timestamp: 1747755000,
            time_slot: "2025-05-20 11:30:00 AM",
          },
          {
            timestamp: 1747758600,
            time_slot: "2025-05-20 12:30:00 PM",
          },
          {
            timestamp: 1747760400,
            time_slot: "2025-05-20  1:00:00 PM",
          },
          {
            timestamp: 1747762200,
            time_slot: "2025-05-20  1:30:00 PM",
          },
          {
            timestamp: 1747764000,
            time_slot: "2025-05-20  2:00:00 PM",
          },
          {
            timestamp: 1747765800,
            time_slot: "2025-05-20  2:30:00 PM",
          },
          {
            timestamp: 1747767600,
            time_slot: "2025-05-20  3:00:00 PM",
          },
          {
            timestamp: 1747769400,
            time_slot: "2025-05-20  3:30:00 PM",
          },
          {
            timestamp: 1747771200,
            time_slot: "2025-05-20  4:00:00 PM",
          },
          {
            timestamp: 1747825200,
            time_slot: "2025-05-21  7:00:00 AM",
          },
          {
            timestamp: 1747827000,
            time_slot: "2025-05-21  7:30:00 AM",
          },
          {
            timestamp: 1747828800,
            time_slot: "2025-05-21  8:00:00 AM",
          },
          {
            timestamp: 1747830600,
            time_slot: "2025-05-21  8:30:00 AM",
          },
          {
            timestamp: 1747832400,
            time_slot: "2025-05-21  9:00:00 AM",
          },
          {
            timestamp: 1747834200,
            time_slot: "2025-05-21  9:30:00 AM",
          },
          {
            timestamp: 1747836000,
            time_slot: "2025-05-21 10:00:00 AM",
          },
          {
            timestamp: 1747837800,
            time_slot: "2025-05-21 10:30:00 AM",
          },
          {
            timestamp: 1747839600,
            time_slot: "2025-05-21 11:00:00 AM",
          },
          {
            timestamp: 1747841400,
            time_slot: "2025-05-21 11:30:00 AM",
          },
          {
            timestamp: 1747845000,
            time_slot: "2025-05-21 12:30:00 PM",
          },
          {
            timestamp: 1747846800,
            time_slot: "2025-05-21  1:00:00 PM",
          },
          {
            timestamp: 1747848600,
            time_slot: "2025-05-21  1:30:00 PM",
          },
          {
            timestamp: 1747850400,
            time_slot: "2025-05-21  2:00:00 PM",
          },
          {
            timestamp: 1747852200,
            time_slot: "2025-05-21  2:30:00 PM",
          },
          {
            timestamp: 1747854000,
            time_slot: "2025-05-21  3:00:00 PM",
          },
          {
            timestamp: 1747915200,
            time_slot: "2025-05-22  8:00:00 AM",
          },
          {
            timestamp: 1747917000,
            time_slot: "2025-05-22  8:30:00 AM",
          },
          {
            timestamp: 1747918800,
            time_slot: "2025-05-22  9:00:00 AM",
          },
          {
            timestamp: 1747920600,
            time_slot: "2025-05-22  9:30:00 AM",
          },
          {
            timestamp: 1747922400,
            time_slot: "2025-05-22 10:00:00 AM",
          },
          {
            timestamp: 1747924200,
            time_slot: "2025-05-22 10:30:00 AM",
          },
          {
            timestamp: 1747926000,
            time_slot: "2025-05-22 11:00:00 AM",
          },
          {
            timestamp: 1747927800,
            time_slot: "2025-05-22 11:30:00 AM",
          },
          {
            timestamp: 1747931400,
            time_slot: "2025-05-22 12:30:00 PM",
          },
          {
            timestamp: 1747933200,
            time_slot: "2025-05-22  1:00:00 PM",
          },
          {
            timestamp: 1747935000,
            time_slot: "2025-05-22  1:30:00 PM",
          },
          {
            timestamp: 1747936800,
            time_slot: "2025-05-22  2:00:00 PM",
          },
          {
            timestamp: 1747938600,
            time_slot: "2025-05-22  2:30:00 PM",
          },
          {
            timestamp: 1747940400,
            time_slot: "2025-05-22  3:00:00 PM",
          },
          {
            timestamp: 1747942200,
            time_slot: "2025-05-22  3:30:00 PM",
          },
          {
            timestamp: 1747944000,
            time_slot: "2025-05-22  4:00:00 PM",
          },
          {
            timestamp: 1748008800,
            time_slot: "2025-05-23 10:00:00 AM",
          },
          {
            timestamp: 1748010600,
            time_slot: "2025-05-23 10:30:00 AM",
          },
          {
            timestamp: 1748012400,
            time_slot: "2025-05-23 11:00:00 AM",
          },
          {
            timestamp: 1748014200,
            time_slot: "2025-05-23 11:30:00 AM",
          },
          {
            timestamp: 1748017800,
            time_slot: "2025-05-23 12:30:00 PM",
          },
          {
            timestamp: 1748019600,
            time_slot: "2025-05-23  1:00:00 PM",
          },
          {
            timestamp: 1748021400,
            time_slot: "2025-05-23  1:30:00 PM",
          },
          {
            timestamp: 1748023200,
            time_slot: "2025-05-23  2:00:00 PM",
          },
          {
            timestamp: 1748084400,
            time_slot: "2025-05-24  7:00:00 AM",
          },
          {
            timestamp: 1748086200,
            time_slot: "2025-05-24  7:30:00 AM",
          },
          {
            timestamp: 1748088000,
            time_slot: "2025-05-24  8:00:00 AM",
          },
          {
            timestamp: 1748089800,
            time_slot: "2025-05-24  8:30:00 AM",
          },
          {
            timestamp: 1748091600,
            time_slot: "2025-05-24  9:00:00 AM",
          },
          {
            timestamp: 1748093400,
            time_slot: "2025-05-24  9:30:00 AM",
          },
          {
            timestamp: 1748095200,
            time_slot: "2025-05-24 10:00:00 AM",
          },
          {
            timestamp: 1748097000,
            time_slot: "2025-05-24 10:30:00 AM",
          },
          {
            timestamp: 1748098800,
            time_slot: "2025-05-24 11:00:00 AM",
          },
          {
            timestamp: 1748100600,
            time_slot: "2025-05-24 11:30:00 AM",
          },
          {
            timestamp: 1748104200,
            time_slot: "2025-05-24 12:30:00 PM",
          },
          {
            timestamp: 1748106000,
            time_slot: "2025-05-24  1:00:00 PM",
          },
          {
            timestamp: 1748107800,
            time_slot: "2025-05-24  1:30:00 PM",
          },
          {
            timestamp: 1748109600,
            time_slot: "2025-05-24  2:00:00 PM",
          },
          {
            timestamp: 1748178000,
            time_slot: "2025-05-25  9:00:00 AM",
          },
          {
            timestamp: 1748179800,
            time_slot: "2025-05-25  9:30:00 AM",
          },
          {
            timestamp: 1748181600,
            time_slot: "2025-05-25 10:00:00 AM",
          },
          {
            timestamp: 1748183400,
            time_slot: "2025-05-25 10:30:00 AM",
          },
          {
            timestamp: 1748185200,
            time_slot: "2025-05-25 11:00:00 AM",
          },
          {
            timestamp: 1748187000,
            time_slot: "2025-05-25 11:30:00 AM",
          },
          {
            timestamp: 1748188800,
            time_slot: "2025-05-25 12:00:00 PM",
          },
          {
            timestamp: 1748190600,
            time_slot: "2025-05-25 12:30:00 PM",
          },
          {
            timestamp: 1748192400,
            time_slot: "2025-05-25  1:00:00 PM",
          },
          {
            timestamp: 1748194200,
            time_slot: "2025-05-25  1:30:00 PM",
          },
          {
            timestamp: 1748196000,
            time_slot: "2025-05-25  2:00:00 PM",
          },
          {
            timestamp: 1748197800,
            time_slot: "2025-05-25  2:30:00 PM",
          },
          {
            timestamp: 1748199600,
            time_slot: "2025-05-25  3:00:00 PM",
          },
          {
            timestamp: 1748264400,
            time_slot: "2025-05-26  9:00:00 AM",
          },
          {
            timestamp: 1748266200,
            time_slot: "2025-05-26  9:30:00 AM",
          },
          {
            timestamp: 1748268000,
            time_slot: "2025-05-26 10:00:00 AM",
          },
          {
            timestamp: 1748269800,
            time_slot: "2025-05-26 10:30:00 AM",
          },
          {
            timestamp: 1748271600,
            time_slot: "2025-05-26 11:00:00 AM",
          },
          {
            timestamp: 1748273400,
            time_slot: "2025-05-26 11:30:00 AM",
          },
          {
            timestamp: 1748275200,
            time_slot: "2025-05-26 12:00:00 PM",
          },
          {
            timestamp: 1748277000,
            time_slot: "2025-05-26 12:30:00 PM",
          },
          {
            timestamp: 1748282400,
            time_slot: "2025-05-26  2:00:00 PM",
          },
          {
            timestamp: 1748284200,
            time_slot: "2025-05-26  2:30:00 PM",
          },
          {
            timestamp: 1748286000,
            time_slot: "2025-05-26  3:00:00 PM",
          },
          {
            timestamp: 1748347200,
            time_slot: "2025-05-27  8:00:00 AM",
          },
          {
            timestamp: 1748349000,
            time_slot: "2025-05-27  8:30:00 AM",
          },
          {
            timestamp: 1748350800,
            time_slot: "2025-05-27  9:00:00 AM",
          },
          {
            timestamp: 1748352600,
            time_slot: "2025-05-27  9:30:00 AM",
          },
          {
            timestamp: 1748354400,
            time_slot: "2025-05-27 10:00:00 AM",
          },
          {
            timestamp: 1748356200,
            time_slot: "2025-05-27 10:30:00 AM",
          },
          {
            timestamp: 1748358000,
            time_slot: "2025-05-27 11:00:00 AM",
          },
          {
            timestamp: 1748359800,
            time_slot: "2025-05-27 11:30:00 AM",
          },
          {
            timestamp: 1748363400,
            time_slot: "2025-05-27 12:30:00 PM",
          },
          {
            timestamp: 1748365200,
            time_slot: "2025-05-27  1:00:00 PM",
          },
          {
            timestamp: 1748367000,
            time_slot: "2025-05-27  1:30:00 PM",
          },
          {
            timestamp: 1748368800,
            time_slot: "2025-05-27  2:00:00 PM",
          },
          {
            timestamp: 1748370600,
            time_slot: "2025-05-27  2:30:00 PM",
          },
          {
            timestamp: 1748372400,
            time_slot: "2025-05-27  3:00:00 PM",
          },
          {
            timestamp: 1748374200,
            time_slot: "2025-05-27  3:30:00 PM",
          },
          {
            timestamp: 1748376000,
            time_slot: "2025-05-27  4:00:00 PM",
          },
          {
            timestamp: 1748430000,
            time_slot: "2025-05-28  7:00:00 AM",
          },
          {
            timestamp: 1748431800,
            time_slot: "2025-05-28  7:30:00 AM",
          },
          {
            timestamp: 1748433600,
            time_slot: "2025-05-28  8:00:00 AM",
          },
          {
            timestamp: 1748435400,
            time_slot: "2025-05-28  8:30:00 AM",
          },
          {
            timestamp: 1748437200,
            time_slot: "2025-05-28  9:00:00 AM",
          },
          {
            timestamp: 1748439000,
            time_slot: "2025-05-28  9:30:00 AM",
          },
          {
            timestamp: 1748440800,
            time_slot: "2025-05-28 10:00:00 AM",
          },
          {
            timestamp: 1748442600,
            time_slot: "2025-05-28 10:30:00 AM",
          },
          {
            timestamp: 1748444400,
            time_slot: "2025-05-28 11:00:00 AM",
          },
          {
            timestamp: 1748446200,
            time_slot: "2025-05-28 11:30:00 AM",
          },
          {
            timestamp: 1748449800,
            time_slot: "2025-05-28 12:30:00 PM",
          },
          {
            timestamp: 1748451600,
            time_slot: "2025-05-28  1:00:00 PM",
          },
          {
            timestamp: 1748453400,
            time_slot: "2025-05-28  1:30:00 PM",
          },
          {
            timestamp: 1748455200,
            time_slot: "2025-05-28  2:00:00 PM",
          },
          {
            timestamp: 1748457000,
            time_slot: "2025-05-28  2:30:00 PM",
          },
          {
            timestamp: 1748458800,
            time_slot: "2025-05-28  3:00:00 PM",
          },
          {
            timestamp: 1748520000,
            time_slot: "2025-05-29  8:00:00 AM",
          },
          {
            timestamp: 1748521800,
            time_slot: "2025-05-29  8:30:00 AM",
          },
          {
            timestamp: 1748523600,
            time_slot: "2025-05-29  9:00:00 AM",
          },
          {
            timestamp: 1748525400,
            time_slot: "2025-05-29  9:30:00 AM",
          },
          {
            timestamp: 1748527200,
            time_slot: "2025-05-29 10:00:00 AM",
          },
          {
            timestamp: 1748529000,
            time_slot: "2025-05-29 10:30:00 AM",
          },
          {
            timestamp: 1748530800,
            time_slot: "2025-05-29 11:00:00 AM",
          },
          {
            timestamp: 1748532600,
            time_slot: "2025-05-29 11:30:00 AM",
          },
          {
            timestamp: 1748536200,
            time_slot: "2025-05-29 12:30:00 PM",
          },
          {
            timestamp: 1748538000,
            time_slot: "2025-05-29  1:00:00 PM",
          },
          {
            timestamp: 1748539800,
            time_slot: "2025-05-29  1:30:00 PM",
          },
          {
            timestamp: 1748541600,
            time_slot: "2025-05-29  2:00:00 PM",
          },
          {
            timestamp: 1748543400,
            time_slot: "2025-05-29  2:30:00 PM",
          },
          {
            timestamp: 1748545200,
            time_slot: "2025-05-29  3:00:00 PM",
          },
          {
            timestamp: 1748547000,
            time_slot: "2025-05-29  3:30:00 PM",
          },
          {
            timestamp: 1748548800,
            time_slot: "2025-05-29  4:00:00 PM",
          },
          {
            timestamp: 1748613600,
            time_slot: "2025-05-30 10:00:00 AM",
          },
          {
            timestamp: 1748615400,
            time_slot: "2025-05-30 10:30:00 AM",
          },
          {
            timestamp: 1748617200,
            time_slot: "2025-05-30 11:00:00 AM",
          },
          {
            timestamp: 1748619000,
            time_slot: "2025-05-30 11:30:00 AM",
          },
          {
            timestamp: 1748622600,
            time_slot: "2025-05-30 12:30:00 PM",
          },
          {
            timestamp: 1748624400,
            time_slot: "2025-05-30  1:00:00 PM",
          },
          {
            timestamp: 1748626200,
            time_slot: "2025-05-30  1:30:00 PM",
          },
          {
            timestamp: 1748628000,
            time_slot: "2025-05-30  2:00:00 PM",
          },
          {
            timestamp: 1748689200,
            time_slot: "2025-05-31  7:00:00 AM",
          },
          {
            timestamp: 1748691000,
            time_slot: "2025-05-31  7:30:00 AM",
          },
          {
            timestamp: 1748692800,
            time_slot: "2025-05-31  8:00:00 AM",
          },
          {
            timestamp: 1748694600,
            time_slot: "2025-05-31  8:30:00 AM",
          },
          {
            timestamp: 1748696400,
            time_slot: "2025-05-31  9:00:00 AM",
          },
          {
            timestamp: 1748698200,
            time_slot: "2025-05-31  9:30:00 AM",
          },
          {
            timestamp: 1748700000,
            time_slot: "2025-05-31 10:00:00 AM",
          },
          {
            timestamp: 1748701800,
            time_slot: "2025-05-31 10:30:00 AM",
          },
          {
            timestamp: 1748703600,
            time_slot: "2025-05-31 11:00:00 AM",
          },
          {
            timestamp: 1748705400,
            time_slot: "2025-05-31 11:30:00 AM",
          },
          {
            timestamp: 1748709000,
            time_slot: "2025-05-31 12:30:00 PM",
          },
          {
            timestamp: 1748710800,
            time_slot: "2025-05-31  1:00:00 PM",
          },
          {
            timestamp: 1748712600,
            time_slot: "2025-05-31  1:30:00 PM",
          },
          {
            timestamp: 1748714400,
            time_slot: "2025-05-31  2:00:00 PM",
          },
          {
            timestamp: 1748782800,
            time_slot: "2025-06-01  9:00:00 AM",
          },
          {
            timestamp: 1748784600,
            time_slot: "2025-06-01  9:30:00 AM",
          },
          {
            timestamp: 1748786400,
            time_slot: "2025-06-01 10:00:00 AM",
          },
          {
            timestamp: 1748788200,
            time_slot: "2025-06-01 10:30:00 AM",
          },
          {
            timestamp: 1748790000,
            time_slot: "2025-06-01 11:00:00 AM",
          },
          {
            timestamp: 1748791800,
            time_slot: "2025-06-01 11:30:00 AM",
          },
          {
            timestamp: 1748793600,
            time_slot: "2025-06-01 12:00:00 PM",
          },
          {
            timestamp: 1748795400,
            time_slot: "2025-06-01 12:30:00 PM",
          },
          {
            timestamp: 1748797200,
            time_slot: "2025-06-01  1:00:00 PM",
          },
          {
            timestamp: 1748799000,
            time_slot: "2025-06-01  1:30:00 PM",
          },
          {
            timestamp: 1748800800,
            time_slot: "2025-06-01  2:00:00 PM",
          },
          {
            timestamp: 1748802600,
            time_slot: "2025-06-01  2:30:00 PM",
          },
          {
            timestamp: 1748804400,
            time_slot: "2025-06-01  3:00:00 PM",
          },
          {
            timestamp: 1748869200,
            time_slot: "2025-06-02  9:00:00 AM",
          },
          {
            timestamp: 1748871000,
            time_slot: "2025-06-02  9:30:00 AM",
          },
          {
            timestamp: 1748872800,
            time_slot: "2025-06-02 10:00:00 AM",
          },
          {
            timestamp: 1748874600,
            time_slot: "2025-06-02 10:30:00 AM",
          },
          {
            timestamp: 1748876400,
            time_slot: "2025-06-02 11:00:00 AM",
          },
          {
            timestamp: 1748878200,
            time_slot: "2025-06-02 11:30:00 AM",
          },
          {
            timestamp: 1748880000,
            time_slot: "2025-06-02 12:00:00 PM",
          },
          {
            timestamp: 1748881800,
            time_slot: "2025-06-02 12:30:00 PM",
          },
          {
            timestamp: 1748887200,
            time_slot: "2025-06-02  2:00:00 PM",
          },
          {
            timestamp: 1748889000,
            time_slot: "2025-06-02  2:30:00 PM",
          },
          {
            timestamp: 1748890800,
            time_slot: "2025-06-02  3:00:00 PM",
          },
          {
            timestamp: 1748952000,
            time_slot: "2025-06-03  8:00:00 AM",
          },
          {
            timestamp: 1748953800,
            time_slot: "2025-06-03  8:30:00 AM",
          },
          {
            timestamp: 1748955600,
            time_slot: "2025-06-03  9:00:00 AM",
          },
          {
            timestamp: 1748957400,
            time_slot: "2025-06-03  9:30:00 AM",
          },
          {
            timestamp: 1748959200,
            time_slot: "2025-06-03 10:00:00 AM",
          },
          {
            timestamp: 1748961000,
            time_slot: "2025-06-03 10:30:00 AM",
          },
          {
            timestamp: 1748962800,
            time_slot: "2025-06-03 11:00:00 AM",
          },
          {
            timestamp: 1748964600,
            time_slot: "2025-06-03 11:30:00 AM",
          },
          {
            timestamp: 1748968200,
            time_slot: "2025-06-03 12:30:00 PM",
          },
          {
            timestamp: 1748970000,
            time_slot: "2025-06-03  1:00:00 PM",
          },
          {
            timestamp: 1748971800,
            time_slot: "2025-06-03  1:30:00 PM",
          },
          {
            timestamp: 1748973600,
            time_slot: "2025-06-03  2:00:00 PM",
          },
          {
            timestamp: 1748975400,
            time_slot: "2025-06-03  2:30:00 PM",
          },
          {
            timestamp: 1748977200,
            time_slot: "2025-06-03  3:00:00 PM",
          },
          {
            timestamp: 1748979000,
            time_slot: "2025-06-03  3:30:00 PM",
          },
          {
            timestamp: 1748980800,
            time_slot: "2025-06-03  4:00:00 PM",
          },
          {
            timestamp: 1749034800,
            time_slot: "2025-06-04  7:00:00 AM",
          },
          {
            timestamp: 1749036600,
            time_slot: "2025-06-04  7:30:00 AM",
          },
          {
            timestamp: 1749038400,
            time_slot: "2025-06-04  8:00:00 AM",
          },
          {
            timestamp: 1749040200,
            time_slot: "2025-06-04  8:30:00 AM",
          },
          {
            timestamp: 1749042000,
            time_slot: "2025-06-04  9:00:00 AM",
          },
          {
            timestamp: 1749043800,
            time_slot: "2025-06-04  9:30:00 AM",
          },
          {
            timestamp: 1749045600,
            time_slot: "2025-06-04 10:00:00 AM",
          },
          {
            timestamp: 1749047400,
            time_slot: "2025-06-04 10:30:00 AM",
          },
          {
            timestamp: 1749049200,
            time_slot: "2025-06-04 11:00:00 AM",
          },
          {
            timestamp: 1749051000,
            time_slot: "2025-06-04 11:30:00 AM",
          },
          {
            timestamp: 1749054600,
            time_slot: "2025-06-04 12:30:00 PM",
          },
          {
            timestamp: 1749056400,
            time_slot: "2025-06-04  1:00:00 PM",
          },
          {
            timestamp: 1749058200,
            time_slot: "2025-06-04  1:30:00 PM",
          },
          {
            timestamp: 1749060000,
            time_slot: "2025-06-04  2:00:00 PM",
          },
          {
            timestamp: 1749061800,
            time_slot: "2025-06-04  2:30:00 PM",
          },
          {
            timestamp: 1749063600,
            time_slot: "2025-06-04  3:00:00 PM",
          },
          {
            timestamp: 1749124800,
            time_slot: "2025-06-05  8:00:00 AM",
          },
          {
            timestamp: 1749126600,
            time_slot: "2025-06-05  8:30:00 AM",
          },
          {
            timestamp: 1749128400,
            time_slot: "2025-06-05  9:00:00 AM",
          },
          {
            timestamp: 1749130200,
            time_slot: "2025-06-05  9:30:00 AM",
          },
          {
            timestamp: 1749132000,
            time_slot: "2025-06-05 10:00:00 AM",
          },
          {
            timestamp: 1749133800,
            time_slot: "2025-06-05 10:30:00 AM",
          },
          {
            timestamp: 1749135600,
            time_slot: "2025-06-05 11:00:00 AM",
          },
          {
            timestamp: 1749137400,
            time_slot: "2025-06-05 11:30:00 AM",
          },
          {
            timestamp: 1749141000,
            time_slot: "2025-06-05 12:30:00 PM",
          },
          {
            timestamp: 1749142800,
            time_slot: "2025-06-05  1:00:00 PM",
          },
          {
            timestamp: 1749144600,
            time_slot: "2025-06-05  1:30:00 PM",
          },
          {
            timestamp: 1749146400,
            time_slot: "2025-06-05  2:00:00 PM",
          },
          {
            timestamp: 1749148200,
            time_slot: "2025-06-05  2:30:00 PM",
          },
          {
            timestamp: 1749150000,
            time_slot: "2025-06-05  3:00:00 PM",
          },
          {
            timestamp: 1749151800,
            time_slot: "2025-06-05  3:30:00 PM",
          },
          {
            timestamp: 1749153600,
            time_slot: "2025-06-05  4:00:00 PM",
          },
          {
            timestamp: 1749218400,
            time_slot: "2025-06-06 10:00:00 AM",
          },
          {
            timestamp: 1749220200,
            time_slot: "2025-06-06 10:30:00 AM",
          },
          {
            timestamp: 1749222000,
            time_slot: "2025-06-06 11:00:00 AM",
          },
          {
            timestamp: 1749223800,
            time_slot: "2025-06-06 11:30:00 AM",
          },
          {
            timestamp: 1749227400,
            time_slot: "2025-06-06 12:30:00 PM",
          },
          {
            timestamp: 1749229200,
            time_slot: "2025-06-06  1:00:00 PM",
          },
          {
            timestamp: 1749231000,
            time_slot: "2025-06-06  1:30:00 PM",
          },
          {
            timestamp: 1749232800,
            time_slot: "2025-06-06  2:00:00 PM",
          },
          {
            timestamp: 1749294000,
            time_slot: "2025-06-07  7:00:00 AM",
          },
          {
            timestamp: 1749295800,
            time_slot: "2025-06-07  7:30:00 AM",
          },
          {
            timestamp: 1749297600,
            time_slot: "2025-06-07  8:00:00 AM",
          },
          {
            timestamp: 1749299400,
            time_slot: "2025-06-07  8:30:00 AM",
          },
          {
            timestamp: 1749301200,
            time_slot: "2025-06-07  9:00:00 AM",
          },
          {
            timestamp: 1749303000,
            time_slot: "2025-06-07  9:30:00 AM",
          },
          {
            timestamp: 1749304800,
            time_slot: "2025-06-07 10:00:00 AM",
          },
          {
            timestamp: 1749306600,
            time_slot: "2025-06-07 10:30:00 AM",
          },
          {
            timestamp: 1749308400,
            time_slot: "2025-06-07 11:00:00 AM",
          },
          {
            timestamp: 1749310200,
            time_slot: "2025-06-07 11:30:00 AM",
          },
          {
            timestamp: 1749313800,
            time_slot: "2025-06-07 12:30:00 PM",
          },
          {
            timestamp: 1749315600,
            time_slot: "2025-06-07  1:00:00 PM",
          },
          {
            timestamp: 1749317400,
            time_slot: "2025-06-07  1:30:00 PM",
          },
          {
            timestamp: 1749319200,
            time_slot: "2025-06-07  2:00:00 PM",
          },
        ],
      },
      {
        search_result: true,
        not_available_filters: [],
        enabled_tour_types: ["in_person_tour", "live_video_tour", "self_guided_tour"],
      },
    ],
    spf_query_response: {
      booking: {
        id: "1831582468788804149",
        property_id: "1528252253585581240",
        service_id: "1528252678198548487",
        entry_id: "1831548115075455918",
        start_at: "2025-05-26T13:30:00.000-04:00",
        // end_at: "2025-05-26T14:30:00.000-04:00",
        end_at: "2025-05-12T06:39:18.000-04:00", //today
        // end_at: "2025-05-13T07:00:00.000-04:00", //tomorrow
        email: "junaida@hy.ly",
        first_name: "Junaid",
        last_name: "Abdullah",
        created_at: "2025-05-08T15:39:18.000-04:00",
        updated_at: "2025-05-08T15:39:19.000-04:00",
        externalBookingId: null,
        status: "CONFIRMED",
        appointmentType: "In-Person Tour",
        // appointmentType: "Live Video Tour",
      },
    },
  },
  message_id: null,
  subject: "schedule a tour",
  available_tourTypes: [],
  not_available: [],
  context: [
    //   {
    //       "preferredTime": "",
    //       "preferredDate": "",
    //       "tourType": "in_person_tour",
    //       "tourAction": "",
    //       "subject": "schedule_a_tour",
    //       "apiClass": "scheduling",
    //       "buffer": ""
    //   }

    //for schedule
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "schedule",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455911",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831583731367657673",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    // },

    // for cancel_inquiry
    // showing form with cancel_inquiry
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "cancel_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: null,
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831583731367657673",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   need_info: "entryId",
    //   required_info: true,
    // },

    // // if user do schedule or book tour
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "cancel_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455911",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831583731367657673",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: false,
    //   required_info: true,
    //   error_code: 404,
    //   error_message: "Hayley-SPF: {'error': 'No booking found'}",
    //   need_info: "booking",
    // },

    //if booking found
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "cancel_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455918",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831583731367657673",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: true,
    //   required_info: false,
    // },

    // {
    //   booking: {
    //     id: "1831582468788804149",
    //     property_id: 1528252253585581240,
    //     service_id: 1528252678198548487,
    //     entry_id: 1831548115075455918,
    //     start_at: "2025-05-26T13:30:00.000-04:00",
    //     end_at: "2025-05-26T14:30:00.000-04:00",
    //     email: "junaida@hy.ly",
    //     first_name: "Junaid",
    //     last_name: "Abdullah",
    //     created_at: "2025-05-08T15:39:18.000-04:00",
    //     updated_at: "2025-05-08T15:39:19.000-04:00",
    //     externalBookingId: null,
    //     status: "CONFIRMED",
    //     appointmentType: "In-Person Tour",
    //   },
    // },

    //cancel_confirmation

    {
      preferredTime: "22:00",
      preferredDate: "2025-12-31",
      tourType: "",
      tourAction: "cancel_confirmation",
      subject: "schedule_a_tour",
      entryId: "1831548115075455918",
      email: null,
      phoneNumber: null,
      bookingId: null,
      slotDateTime: "2025-05-26 13:30:00",
      apiClass: "confirmation",
      buffer: "",
      need_info: "bookingId",
      required_info: true,
    },

    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "cancel_confirmation",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455918",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831588084802888691",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: true,
    //   required_info: false,
    // },

    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "cancel_confirmation",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455918",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831583731367657673",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: false,
    //   required_info: false,
    //   error_code: 404,
    //   error_message: "Hayley-SPF: {'error': 'No Booking Found'}",
    // },

    //for Reschedule tour

    //when required_info is true and need_info is entryId
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "reschedule_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: null,
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: null,
    //   slotDateTime: null,
    //   apiClass: "confirmation",
    //   buffer: "",
    //   need_info: "entryId",
    //   required_info: true,
    // },

    // when booking found true and required info is false
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "reschedule_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455918",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: null,
    //   slotDateTime: null,
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: true,
    //   required_info: false,
    // },

    // when booking not found and required info is true and status code is 404
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-12-31",
    //   tourType: "",
    //   tourAction: "reschedule_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455911",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: null,
    //   slotDateTime: null,
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: false,
    //   required_info: true,
    //   error_code: 404,
    //   error_message: "Hayley-SPF: {'error': 'No booking found'}",
    //   need_info: "booking",
    // },

    //when tourAction is rescheduleConfirmation
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-05-09..2025-05-09",
    //   tourType: "",
    //   tourAction: "reschedule_confirmation",
    //   subject: "schedule_a_tour",
    //   entryId: null,
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831622724245541048",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: true,
    //   required_info: false,
    // },

    //for status inquiry

    // required_info is true and need_info is entryId
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-05-09..2025-05-09",
    //   tourType: "",
    //   tourAction: "status_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: null,
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831622724245541048",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   need_info: "entryId",
    //   required_info: true,
    // },

    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-05-09..2025-05-09",
    //   tourType: "",
    //   tourAction: "status_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455911",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831622724245541048",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: false,
    //   required_info: true,
    //   error_code: 404,
    //   error_message: "Hayley-SPF: {'error': 'No booking found'}",
    //   need_info: "booking",
    // },

    // if book_found true and required_info is false
    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-05-09..2025-05-09",
    //   tourType: "",
    //   tourAction: "status_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: "1831548115075455918",
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: "1831622724245541048",
    //   slotDateTime: "2025-05-26 13:30:00",
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: true,
    //   required_info: false,
    // },

    // tour_type_inquiry

    // {
    //   preferredTime: "22:00",
    //   preferredDate: "2025-05-09..2025-05-09",
    //   tourType: "",
    //   tourAction: "tour_type_inquiry",
    //   subject: "schedule_a_tour",
    //   entryId: null,
    //   email: null,
    //   phoneNumber: null,
    //   bookingId: null,
    //   slotDateTime: null,
    //   apiClass: "confirmation",
    //   buffer: "",
    //   booking_found: true,
    //   required_info: false,
    // },
  ],
  neighborhood_summary: "",
  follow_up: {
    tour_scheduled: {
      text: "You have a tour already booked. Would you like to cancel it or adjust any details?",
      key: "",
    },
    tour_not_scheduled: {
      text: "Would you like to visit us at this time?",
      key: "",
    },
  },
  latency: {
    retreive_preference_context: {
      response_time: 0.14229416847229004,
    },
    agent_orchestrator_microservice: {
      network_latency: 2.8368,
      processing_latency: "2.8136 s",
    },
    translate_to_human_latency: {
      processing_latency: "0.04 s",
      network_latency: 0.0698,
    },
    hayley_engine_latency: "3.07 s",
    chat_adapter_latency: 3.68,
  },
  images_url: "",
  preference_context: {
    entryId: "",
    desiredBedrooms: 1,
    desiredPriceLow: 0,
    desiredPriceHigh: 1000,
    desiredMoveIn: "2026-03-28",
    touredAt: "",
    scheduledAt: "",
    meta: '{"date_type":"before"}',
  },
};
